import { __assign, __extends, __rest, __spreadArray } from "tslib";
import React from 'react';
import { View, Image, ScrollView, Platform, StyleSheet, TouchableOpacity, Text, Linking, Dimensions } from 'react-native';
import { PnmacRowItem, PnmacTextInput, PnmacCard, PnmacUIButton, PnmacText, PnmacTable, PnmacToolTip, PnmacModal, PnmacHtmlToNative, PnmacNavigation, PnmacPaper, LocalStorage, theme, PnmacCheckBox, HtmlToNativeNative } from 'pnmac-universal-components';
import { PAYMENT_VALIDATION, RESET_STATE } from '../../../redux/actions/actions.js';
import BankAccounts from '../Platform/BankAccounts.native.js';
import { maskBankInfo, getActiveFeatures, getActiveFeaturesDescription, checkForAllNumbersCurrency, currencyFormatter, paymentStatus, paymentTypes, ammountPaymentAhead, RuleId, defaulPaymentType, defaulPaymentTypeStr, testID, encryptBankAccountNumber } from '../../../utils.js';
import BannerView from '../../../v2/BannerView';
import { textStyle } from '../../../v2/theme';
import moment from 'moment';
import styles from '../../../styles/styles.js';
import { TrackerHitTypeLID_ENUM, TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, UserLanguage_ENUM } from '../../../redux/events/events.js';
import { NACHA_BANKACCOUNT, CLOSED_END_SECONDS } from '../../../redux/actions/actions.js';
import Rate from '../../../PnmacRate';
import { OTPDatePicker } from '../../../DatePicker/index.js';
import { isPrivateLabelHost, isPennymacHost } from '../../../utils.js';
import DeviceInfo from 'react-native-device-info';
var width = Dimensions.get('window').width;
String.prototype.countDecimals = function () {
  var numStr = String(this.valueOf());
  if (numStr.includes('.')) {
    return numStr.split('.')[1].length;
  }
  ;
  return 0;
};
var useStyles = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 500,
    margin: 'auto'
  },
  paper: {
    backgr42oundColor: 'white',
    borderRadius: 10,
    padding: 20,
    margin: 20
  },
  consrm: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginLeft: -10,
    marginBottom: 10
  },
  root: {
    width: '90%',
    '& > * + *': {
      marginTop: 2
    }
  }
};
function TransitionsModal(_a) {
  var _b, _c, _d, _e, _f, _g;
  var matches = _a.matches,
    open = _a.open,
    closeModal = _a.closeModal,
    paymentCallback = _a.paymentCallback,
    translations = _a.translations,
    modalType = _a.modalType,
    layout = _a.layout,
    nextPaymentDueDate = _a.nextPaymentDueDate,
    displayedConfirmationId = _a.displayedConfirmationId,
    firstMonthlyPaymentDate = _a.firstMonthlyPaymentDate,
    getPaymentConfirmationRenderModel = _a.getPaymentConfirmationRenderModel,
    showPaymentModel = _a.showPaymentModel,
    rest = __rest(_a, ["matches", "open", "closeModal", "paymentCallback", "translations", "modalType", "layout", "nextPaymentDueDate", "displayedConfirmationId", "firstMonthlyPaymentDate", "getPaymentConfirmationRenderModel", "showPaymentModel"]);
  var display = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
      "pendingPayments": {
        hr: translations === null || translations === void 0 ? void 0 : translations.MakeOTPMonthlyPaymentAlertModalTitle,
        id: 1,
        body: (_a = translations === null || translations === void 0 ? void 0 : translations.MakeOTPMonthlyPaymentAlertModalMessage) === null || _a === void 0 ? void 0 : _a.replace("{0}", moment(nextPaymentDueDate).format("MM/DD/YYYY")),
        buttonOne: translations === null || translations === void 0 ? void 0 : translations.ACHAlertModalNo,
        buttonTwo: translations === null || translations === void 0 ? void 0 : translations.MakeOTPMonthlyPaymentAlertModalContinue,
        buttonOneClick: function () {
          PnmacNavigation(__assign({
            action: {
              pathname: "/"
            },
            layout: layout
          }, rest));
          showPaymentModel();
          // closeModal()
        },
        buttonTwoClick: function () {
          return closeModal();
        }
      },
      "effectiveDateConfirmation": {
        hr: translations === null || translations === void 0 ? void 0 : translations.EffectiveDateConfirmation,
        id: 2,
        body: getActiveFeatures(layout.features, "View_NACHA", false) ? "<span data-focusable=\"true\" tabindex=\"0\"><span>".concat(translations === null || translations === void 0 ? void 0 : translations.CanCancelPayment, "</span><br /><br /><span>").concat(translations === null || translations === void 0 ? void 0 : translations.NachaBankAccountBusinessValidationMessage1, "</span><br /><br /><span>").concat(translations === null || translations === void 0 ? void 0 : translations.NachaBankAccountBusinessValidationMessage2, "</span></span>") : "<span><span>".concat(translations === null || translations === void 0 ? void 0 : translations.CanCancelPayment, "</span></span>"),
        buttonOne: translations === null || translations === void 0 ? void 0 : translations.ACHAlertModalNo,
        buttonTwo: translations === null || translations === void 0 ? void 0 : translations.ACHAlertModalYes,
        buttonOneClick: function () {
          closeModal();
          rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "changed mind on effective date pop up", 0);
        },
        buttonTwoClick: function () {
          paymentCallback();
          rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "yes confirm on effective date pop up", 0);
        }
      },
      "paymentConfirmation": {
        hr: 'paymentConfirmation',
        id: 3,
        body: getActiveFeatures(layout.features, "View_NACHA", false) ? "<span data-focusable=\"true\" tabindex=\"0\"><span>".concat(translations === null || translations === void 0 ? void 0 : translations.CanCancelPayment, "</span><br /><br /><span>").concat(translations === null || translations === void 0 ? void 0 : translations.NachaBankAccountBusinessValidationMessage1, "</span><br /><br /><span>").concat(translations === null || translations === void 0 ? void 0 : translations.NachaBankAccountBusinessValidationMessage2, "</span></span>") : "<span><span>".concat(translations === null || translations === void 0 ? void 0 : translations.CanCancelPayment, "</span></span>"),
        buttonOne: translations === null || translations === void 0 ? void 0 : translations.ACHAlertModalNo,
        buttonTwo: translations === null || translations === void 0 ? void 0 : translations.ACHAlertModalYes,
        buttonOneClick: function () {
          closeModal();
          rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "changed mind on effective date pop up", 0);
        },
        buttonTwoClick: function () {
          paymentCallback();
          rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "yes confirm on effective date pop up", 0);
        }
      },
      "pendingOneTimePayment": {
        hr: translations === null || translations === void 0 ? void 0 : translations.YouHavePendingMonthlyPayment,
        id: 4,
        body: "".concat(translations === null || translations === void 0 ? void 0 : translations.OTPMonthlyPaymentAlreadyscheduledMsg1, " ").concat(moment(firstMonthlyPaymentDate).format("MM/DD/YYYY"), " ").concat(translations === null || translations === void 0 ? void 0 : translations.OTPMonthlyPaymentAlreadyscheduledMsg2),
        buttonOne: translations === null || translations === void 0 ? void 0 : translations.ACHAlertModalNo,
        buttonTwo: translations === null || translations === void 0 ? void 0 : translations.ACHAlertModalYes,
        buttonOneClick: function () {
          return closeModal();
        },
        buttonTwoClick: function () {
          return paymentCallback(true);
        }
      },
      "oneDelinquentPayment": {
        hr: translations === null || translations === void 0 ? void 0 : translations.OtpDelAlertModalTitle,
        id: 5,
        body: "<span><span>".concat(translations === null || translations === void 0 ? void 0 : translations.OtpDelAlertMessageLine1, "</span><br /><span>").concat(translations === null || translations === void 0 ? void 0 : translations.OtpDelAlertMessageLine2, "</span></span>"),
        buttonOne: translations === null || translations === void 0 ? void 0 : translations.ACHAlertModalNo,
        buttonTwo: translations === null || translations === void 0 ? void 0 : translations.ACHAlertModalYes,
        buttonOneClick: function () {
          return closeModal();
        },
        buttonTwoClick: function () {
          return paymentCallback(true);
        }
      },
      "paymentSubmitted": ((_b = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _b === void 0 ? void 0 : _b.lienPriorityType) == 2 && !(((_c = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _c === void 0 ? void 0 : _c.pendingPayments) || []).some(function (d) {
        return d.paymentType == 201309;
      }) ? {
        hr: translations === null || translations === void 0 ? void 0 : translations.PaymentSubmitted,
        id: 6,
        body: "<span><span>".concat(translations.PaymentSubmittedMessage, "</span><span>").concat((_d = translations.PaymentConfirmationNumberMessage) === null || _d === void 0 ? void 0 : _d.replace("{0}", "<b>".concat(displayedConfirmationId, "</b>")), "</span><br/><br/>").concat(translations.CesAchComplete, "</span>"),
        buttonOne: translations.PaymentButtonEnroll,
        buttonTwo: translations.NoContinue,
        buttonOneClick: function () {
          PnmacNavigation(__assign({
            action: {
              pathname: "/Payment/Ach"
            },
            layout: layout
          }, rest));
          closeModal();
          rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Go to ACH payment CES Clicked ", 0);
        },
        buttonTwoClick: function () {
          var _a;
          PnmacNavigation(__assign({
            action: {
              pathname: "/Payment/Pending"
            },
            layout: layout
          }, rest));
          closeModal();
          rest.refreshBankData(layout.selectedLoanNumber);
          rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "No thanks ACH CES Clicked", 0);
          if (getActiveFeatures(layout.features, "in_app_survey", layout.whitelisted) && !rest.edit) {
            var days = getActiveFeaturesDescription(layout.features, "in_app_survey");
            days = days ? JSON.parse(days).surveyTimeoutInDays : 1000;
            var tocount = (_a = layout.reviews) === null || _a === void 0 ? void 0 : _a.find(function (s) {
              return s.daysSinceLastSeen <= days;
            });
            var appDevice_1 = Platform.select({
              android: "Android",
              ios: "IOS"
            });
            if (!tocount) {
              Rate.rate(function (success, errorMessage) {
                if (success) {
                  // this technically only tells us if the user successfully went to the Review Page. Whether they actually did anything, we do not know.
                  rest.review_request();
                  rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "".concat(appDevice_1, " - User successfully went to the mobile survey."), 0);
                }
                if (errorMessage) {
                  // errorMessage comes from the native code. Useful for debugging, but probably not for users to view
                  rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "".concat(appDevice_1, " - Something went wrong with appstore lib"), 0);
                }
              });
              rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "".concat(appDevice_1, " - Request to app stores for a mobile survey"), 0);
            } else {
              rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "".concat(appDevice_1, " - Criteria not met to send survey req to app store"), 0);
            }
          }
        }
      } : layout.closedEndSeconds && ((_e = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _e === void 0 ? void 0 : _e.lienPriorityType) != 2 && layout.closedEndSeconds.loanId != layout.selectedLoanNumber && (((_f = layout === null || layout === void 0 ? void 0 : layout.closedEndSeconds) === null || _f === void 0 ? void 0 : _f.pendingPayments.filter(function (d) {
        return d.status != 201295 && !(d.paymentType == 201309 && moment(d.effectiveDate).month() > moment().month());
      })) || []).length == 0 ? {
        hr: translations === null || translations === void 0 ? void 0 : translations.PaymentSubmitted,
        id: 7,
        body: "<span><span>".concat(translations.PaymentSubmittedMessage, "</span><span>").concat((_g = translations.PaymentConfirmationNumberMessage) === null || _g === void 0 ? void 0 : _g.replace("{0}", "<b>".concat(displayedConfirmationId, "</b>")), "</span><br/><br/>").concat(translations.ClosedEndSeconds, "</span>"),
        buttonOne: translations.PaymentButtonYes,
        buttonTwo: translations.PaymentButtonNo,
        buttonOneClick: function () {
          LocalStorage.storeDataString("PennyTime", layout.closedEndSeconds.loanId);
          PnmacNavigation(__assign({
            action: {
              pathname: "/ClosedEndSeconds"
            },
            layout: layout
          }, rest));
          closeModal();
          rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Go to one time payment CES Clicked ", 0);
          rest.dispatch({
            type: RESET_STATE,
            seconds: true
          });
          rest.authenticate();
        },
        buttonTwoClick: function () {
          var _a;
          PnmacNavigation(__assign({
            action: {
              pathname: "/Payment/Pending"
            },
            layout: layout
          }, rest));
          closeModal();
          rest.refreshBankData(layout.selectedLoanNumber);
          rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "No thanks CES Clicked", 0);
          if (getActiveFeatures(layout.features, "in_app_survey", layout.whitelisted) && !rest.edit) {
            var days = getActiveFeaturesDescription(layout.features, "in_app_survey");
            days = days ? JSON.parse(days).surveyTimeoutInDays : 1000;
            var tocount = (_a = layout.reviews) === null || _a === void 0 ? void 0 : _a.find(function (s) {
              return s.daysSinceLastSeen <= days;
            });
            var appDevice_2 = Platform.select({
              android: "Android",
              ios: "IOS"
            });
            if (!tocount) {
              Rate.rate(function (success, errorMessage) {
                if (success) {
                  // this technically only tells us if the user successfully went to the Review Page. Whether they actually did anything, we do not know.
                  rest.review_request();
                  rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "".concat(appDevice_2, " - User successfully went to the mobile survey."), 0);
                }
                if (errorMessage) {
                  // errorMessage comes from the native code. Useful for debugging, but probably not for users to view
                  rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "".concat(appDevice_2, " - Something went wrong with appstore lib"), 0);
                }
              });
              rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "".concat(appDevice_2, " - Request to app stores for a mobile survey"), 0);
            } else {
              rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "".concat(appDevice_2, " - Criteria not met to send survey req to app store"), 0);
            }
          }
        }
      } : {
        hr: translations === null || translations === void 0 ? void 0 : translations.PaymentSubmitted,
        id: 8,
        body: "<span><span>".concat(translations.PaymentSubmittedMessage, "</span><span>").concat((_h = translations.PaymentConfirmationNumberMessage) === null || _h === void 0 ? void 0 : _h.replace("{0}", "<b>".concat(displayedConfirmationId, "</b>")), "</span></span>"),
        buttonOne: null,
        buttonTwo: translations === null || translations === void 0 ? void 0 : translations.ModalPopupOkButtonText,
        buttonOneClick: null,
        buttonTwoClick: function () {
          var _a;
          PnmacNavigation(__assign({
            action: {
              pathname: "/Payment/Pending"
            },
            layout: layout
          }, rest));
          closeModal();
          rest.refreshBankData(layout.selectedLoanNumber);
          if (getActiveFeatures(layout.features, "in_app_survey", layout.whitelisted) && !rest.edit) {
            var days = getActiveFeaturesDescription(layout.features, "in_app_survey");
            days = days ? JSON.parse(days).surveyTimeoutInDays : 1000;
            var tocount = (_a = layout.reviews) === null || _a === void 0 ? void 0 : _a.find(function (s) {
              return s.daysSinceLastSeen <= days;
            });
            var appDevice_3 = Platform.select({
              android: "Android",
              ios: "IOS"
            });
            if (!tocount) {
              Rate.rate(function (success, errorMessage) {
                if (success) {
                  // this technically only tells us if the user successfully went to the Review Page. Whether they actually did anything, we do not know.
                  rest.review_request();
                  rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "".concat(appDevice_3, " - User successfully went to the mobile survey."), 0);
                }
                if (errorMessage) {
                  // errorMessage comes from the native code. Useful for debugging, but probably not for users to view
                  rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "".concat(appDevice_3, " - Something went wrong with appstore lib"), 0);
                }
              });
              rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "".concat(appDevice_3, " - Request to app stores for a mobile survey"), 0);
            } else {
              rest.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Landing, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "".concat(appDevice_3, " - Criteria not met to send survey req to app store"), 0);
            }
          }
        }
      },
      "achPaymentSubmitted": {
        id: 9,
        hr: translations === null || translations === void 0 ? void 0 : translations.ApplicationSubmitted,
        body: translations.AutoPaySubmittedMessageLine1,
        buttonOne: null,
        buttonTwo: translations === null || translations === void 0 ? void 0 : translations.Close,
        buttonOneClick: null,
        buttonTwoClick: function () {
          PnmacNavigation(__assign({
            action: {
              pathname: "/Payment/Ach"
            },
            layout: layout
          }, rest));
          closeModal();
        }
      }
    }[modalType];
  };
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacModal, {
    open: open,
    style: {
      borderRadius: 10,
      minHeight: '50%',
      maxHeight: '60%',
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: '40%'
    }
  }, display().hr == "Payment submitted" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
    style: {
      borderRadius: 8,
      backgroundColor: '#ffffff',
      marginVertical: 30
    }
  }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('ApplicationSubmitted'), {
    style: __assign(__assign({}, theme.textStyle.modalTitle), {
      fontFamily: "Montserrat",
      fontWeight: "bold",
      textAlign: 'center',
      fontSize: 22,
      paddingTop: 30,
      color: "#333333"
    })
  }), "Payment Submitted"), /*#__PURE__*/React.createElement(View, {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-around',
      paddingVertical: 15
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      marginLeft: 14,
      marginRight: 14
    }
  }, /*#__PURE__*/React.createElement(ScrollView, null, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, rest, {
    layout: layout,
    value: (_b = display()) === null || _b === void 0 ? void 0 : _b.body,
    style: __assign(__assign({}, theme.textStyle.modalDesc), {
      color: '#6B6B6B',
      textAlign: 'center',
      fontSize: 13
    })
  }))))), /*#__PURE__*/React.createElement(View, {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-around',
      // borderBottomColor: '#1B1B1B',
      // borderBottomWidth: 0.5,
      paddingHorizontal: 8,
      paddingVertical: 20
    }
  }, /*#__PURE__*/React.createElement(PnmacUIButton, __assign({
    marginTop: 15,
    style: {
      width: '80%',
      height: 47,
      justifyContent: "center"
    },
    mode: "contained"
  }, testID('Close'), {
    onPress: function () {
      display().buttonTwoClick();
    }
  }), translations === null || translations === void 0 ? void 0 : translations.Close)))) : display().hr != 'paymentConfirmation' ? /*#__PURE__*/React.createElement(View, {
    accessibilityRole: layout.mobile ? "alert" : "dialog",
    accessibilityLabel: "One time payment confirmation information",
    style: __assign(__assign({}, useStyles.paper), {
      maxWidth: matches.small ? "90%" : 500,
      maxHeight: "50% !important",
      flex: 1,
      flexDirection: "column",
      backgroundColor: '#FFF'
    })
  }, /*#__PURE__*/React.createElement(View, {
    accessibilityRole: "header",
    accessibilityLevel: 1
  }, /*#__PURE__*/React.createElement(PnmacText, {
    idTag1: "txtOTPPaymentConfirmation",
    style: __assign(__assign({}, textStyle.defaultTextTitle), {
      textAlign: "",
      marginBottom: 20
    })
  }, (_c = display()) === null || _c === void 0 ? void 0 : _c.hr)), /*#__PURE__*/React.createElement(ScrollView, null, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, rest, {
    layout: layout,
    value: (_d = display()) === null || _d === void 0 ? void 0 : _d.body
  }))), /*#__PURE__*/React.createElement(View, {
    style: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    }
  }, ((_e = display()) === null || _e === void 0 ? void 0 : _e.buttonOne) ? /*#__PURE__*/React.createElement(PnmacUIButton, {
    idTag1: 'btnButtonOne',
    idTag7: 'txtOne',
    testID: "ModalPopupOkButtonText",
    mode: 'outlined',
    style: __assign(__assign({}, styles.accountSettings.button), {
      width: matches.small ? "90%" : "50%",
      marginTop: 50
    }),
    onPress: function () {
      display().buttonOneClick();
    }
  }, (_f = display()) === null || _f === void 0 ? void 0 : _f.buttonOne) : null, /*#__PURE__*/React.createElement(PnmacUIButton, {
    mode: 'contained',
    idTag1: 'btnButtonTwo',
    idTag7: 'txtTwo',
    style: __assign(__assign({}, styles.accountSettings.button), {
      width: matches.small ? "90%" : "50%",
      marginTop: 25
    }),
    testID: "ModalPopupOkButtonText",
    onPress: function () {
      display().buttonTwoClick();
    }
  }, (_g = display()) === null || _g === void 0 ? void 0 : _g.buttonTwo))) : /*#__PURE__*/React.createElement(View, null, getPaymentConfirmationRenderModel())));
}
var OneTimePaymentNative = /** @class */function (_super) {
  __extends(OneTimePaymentNative, _super);
  function OneTimePaymentNative(props) {
    var _this = _super.call(this, props) || this;
    _this.intiialState = function (props) {
      return {
        selectedView: 'PaymentMethodOneTimePayment',
        isPaymentMethodUpdated: false,
        isNachaOpen: false,
        paymentType: "monthly",
        account: "",
        addBankAccount: false,
        paymentSubmitted: false,
        open: false,
        modalType: 'pendingPayments',
        page: null,
        modalOpenEl: false,
        confirmation: false,
        modalData: {},
        openedTerms: false,
        saturday: false,
        isMounted: false,
        draftDate: false,
        edit: false,
        openDebit: false,
        deliquentPayment: false,
        displayedConfirmationId: "6101",
        errors: {},
        canMakePrincipleReduction: true,
        canMakeAdditionalAmounts: true,
        originalNextPaymentDueDate: null,
        nextPaymentDueDate: null,
        pendingPaymentDate: null,
        otpBanking: false,
        achExist: false,
        tabProgression: ["pay"],
        openCancelAch: false,
        pathname: "",
        currentServerDateTime: "0001-01-01T00:00:00",
        currentSelectedDate: moment(props.layout.localTime),
        isCurrentSelectedDateUpdated: false,
        payment: {
          "delinquentPayments": [],
          "mobile": props.layout.mobile || false,
          "loanId": 0,
          "errors": {},
          "isCancelable": false,
          "errorToDisplayToUser": null,
          "suspenseCode": null,
          "bankAccount": {
            "bankAccountType": 201287
          },
          "suspenseAmount": "0.00",
          "paymentId": 0,
          "monthlyPaymentAmount": "0.00",
          "doubleMonthlyPaymentAmount": 0,
          "numberOfPayments": 1,
          "originalEffectiveDate": null,
          "isEditable": false,
          "feesDues": [{
            "feeAmtField": "0.00",
            "feeCodeField": "1",
            "sequenceNumberField": "0.00",
            "fieldName": "lateFeesDue"
          }, {
            "feeAmtField": "0.00",
            "feeCodeField": "2",
            "sequenceNumberField": 0,
            "fieldName": "nsfFeesDue"
          }, {
            "feeAmtField": "0.00",
            "feeCodeField": "G",
            "sequenceNumberField": 0,
            "fieldName": "debitCardConvenienceFee"
          }, {
            "feeAmtField": "0.00",
            "feeCodeField": "1",
            "sequenceNumberField": 0,
            "fieldName": "otherFeesDue"
          }],
          "totalFeesAmount": "0.00",
          "additionalEscrowAmount": "0.00",
          "requestedByUserName": null,
          "paymentType": null,
          "source": 0,
          "paymentUrl": null,
          "forbearanceAmount": "0.00",
          "userAgent": null,
          "delinquentPaymentAmount": "0.00",
          "delinquentPaymentDueDate": null,
          "nextDelinquentPaymentDate": "0001-01-01T00:00:00",
          "currentPrincipalBalance": 0.0,
          "logId": null,
          "otdRequestQueue": null,
          "isFromCashQueue": false,
          "loanSummary": {},
          "draftSource": 0,
          "isPostedToLoanservices": false,
          "dueDate": null,
          "mspDueDate": null,
          "effectiveDate": moment(props.layout.localTime),
          "achRegisterationConfirmationId": 0,
          "totalDraftAmount": "0.00",
          "additionalPrincipalAmount": "0.00",
          "status": 0,
          "bankRoutingTransitNumber": null,
          "bankAccountNumber": null,
          "bankAccountType": 201287,
          "bankAccountName": null,
          "hasPaymentChange": false,
          "created": moment(props.layout.localTime),
          "createdBy": null,
          "modified": moment(props.layout.localTime),
          "modifiedBy": null,
          "achConfigurationKey": null,
          "paymentMethod": 0,
          "fiservConfirmationNumber": null
        }
      };
    };
    _this.submitPayment = function (selectedBankAccount) {
      var _a, _b, _c, _d, _e, _f;
      var _g = _this.props,
        layout = _g.layout,
        holdViewOpen = _g.holdViewOpen,
        isOtp = _g.isOtp;
      var bankAccountType = _this.state.payment.bankAccount.bankAccountType;
      var edit = _this.state.edit;
      if (parseInt(layout.selectedLoanNumber) > 0) {
        _this.setState({
          paymentSubmitted: true
        });
        var payment_1 = _this.state.payment;
        payment_1.loan = layout.currentLoan;
        payment_1.loanId = layout.selectedLoanNumber;
        payment_1.totalDraftAmount = _this.totalDraftAmountFun(true);
        payment_1.doubleMonthlyPaymentAmount = _this.replaceDollarSign(payment_1.doubleMonthlyPaymentAmount);
        payment_1.bankAccount = selectedBankAccount;
        if ((_a = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _a === void 0 ? void 0 : _a.mustMakeDelinquentPayment) {
          if (layout.paymentModel.numberofPendingPayments > (edit ? ((_c = (_b = layout.paymentModel) === null || _b === void 0 ? void 0 : _b.payment) === null || _c === void 0 ? void 0 : _c.totalDraftAmount) >= parseFloat(payment_1 === null || payment_1 === void 0 ? void 0 : payment_1.delinquentPaymentAmount) + _this.totalFees() ? 0 : 1 : 0)) {
            payment_1.monthlyPaymentAmount = payment_1.delinquentMonthlyPaymentAmount;
            payment_1.dueDate = payment_1.nextDelinquentPaymentDate;
          } else {
            payment_1.monthlyPaymentAmount = payment_1.delinquentPaymentAmount;
            payment_1.dueDate = payment_1.delinquentPaymentDueDate;
          }
        }
        Object.keys(payment_1).map(function (s) {
          if ("suspenseAmount,monthlyPaymentAmount,totalFeesAmount,additionalEscrowAmount,delinquentPaymentAmount,additionalPrincipalAmount".indexOf(s) > -1) {
            payment_1[s] = isNaN(_this.replaceDollarSign(payment_1[s])) ? 0.00 : _this.replaceDollarSign(payment_1[s]);
          }
        });
        if (payment_1.paymentType == 201297 && ((_d = payment_1 === null || payment_1 === void 0 ? void 0 : payment_1.feesDues) === null || _d === void 0 ? void 0 : _d.find(function (s) {
          return s.fieldName == "debitCardConvenienceFee";
        }))) {
          var indexdebit = payment_1.feesDues.findIndex(function (s) {
            return s.fieldName == "debitCardConvenienceFee";
          });
          payment_1.feesDues.splice(indexdebit, 1);
        }
        if (parseInt(bankAccountType) != 201288 && ((_e = payment_1 === null || payment_1 === void 0 ? void 0 : payment_1.feesDues) === null || _e === void 0 ? void 0 : _e.find(function (s) {
          return s.fieldName == "debitCardConvenienceFee";
        }))) {
          var index = payment_1.feesDues.findIndex(function (s) {
            return s.fieldName == "debitCardConvenienceFee";
          });
          payment_1.feesDues.splice(index, 1);
        }
        if (((_f = payment_1 === null || payment_1 === void 0 ? void 0 : payment_1.feesDues) === null || _f === void 0 ? void 0 : _f.length) > 0) {
          payment_1.feesDues = payment_1 === null || payment_1 === void 0 ? void 0 : payment_1.feesDues.filter(function (s) {
            return parseFloat(s.feeAmtField) > 0;
          });
          payment_1.feesDues.forEach(function (d) {
            return delete d._feeAmtField;
          });
        }
        if (!isOtp) {
          payment_1.draftSource = 4;
        }
        payment_1.effectiveDate = moment(payment_1.effectiveDate, "MM/DD/YYYY").isValid() ? moment(payment_1.effectiveDate, "").format("MM/DD/YYYY") : moment(payment_1.effectiveDate).format("MM/DD/YYYY");
        payment_1.mobile = layout.mobile;
        switch (payment_1.paymentType) {
          // Forbearance
          case 1000145:
          case 1000146:
            {
              _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/Payment Type-Forbearance Payment|Mobile', -1, JSON.stringify({
                isOtp: isOtp,
                edit: edit
              }), false);
              break;
            }
          // Mod Trial
          case 201296:
            {
              _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/Payment Type-Mod Trial Payment|Mobile', -1, JSON.stringify({
                isOtp: isOtp,
                edit: edit
              }), false);
              break;
            }
        }
        fetch("".concat(layout.pennyHomeUrl, "api/payment/").concat(!isOtp ? edit ? "update_ach" : "post_ach" : edit ? "update_payment" : "post_payment"), {
          method: 'POST',
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": "Bearer ".concat(_this.props.layout.token),
            "TrackerSessionId": "".concat(_this.props.layout.trackerSession)
          },
          body: JSON.stringify(__assign(__assign({}, payment_1), {
            bankAccount: __assign(__assign({}, payment_1.bankAccount), {
              unmaskedAccountNumber: undefined,
              unmaskedAccountNumberEncode: encryptBankAccountNumber(payment_1.bankAccount.unmaskedAccountNumber),
              confirmAccountNumber: undefined,
              confirmAccountNumberEncode: encryptBankAccountNumber(payment_1.bankAccount.confirmAccountNumber)
            })
          }))
        }).then(function (res) {
          return res.json();
        }).then(function (data) {
          var _a, _b, _c, _d, _e;
          if (data && (((_a = Object.keys(data === null || data === void 0 ? void 0 : data.errors)) === null || _a === void 0 ? void 0 : _a.length) == 0 || !(data === null || data === void 0 ? void 0 : data.errors))) {
            payment_1.status = 0;
            payment_1.canCancel = false;
            payment_1.canEdit = false;
            if (parseInt((_b = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _b === void 0 ? void 0 : _b.lienPriorityType) == 2) {
              if ((_c = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _c === void 0 ? void 0 : _c.pendingPayments) {
                layout.paymentModel.pendingPayments.push(payment_1);
              } else {
                layout.paymentModel.pendingPayments = [payment_1];
              }
              _this.props.dispatch({
                type: CLOSED_END_SECONDS,
                payment: layout.paymentModel
              });
            }
            _this.setState({
              displayedConfirmationId: data.displayedConfirmationId || "6101",
              open: true,
              paymentSubmitted: false,
              modalType: !isOtp ? "achPaymentSubmitted" : "paymentSubmitted",
              page: isOtp ? "pay" : "confirm"
            }, function () {
              if (holdViewOpen) {
                holdViewOpen();
              }
            });
          } else {
            var errorType = data === null || data === void 0 ? void 0 : data.errors;
            if ((_d = data === null || data === void 0 ? void 0 : data.errors) === null || _d === void 0 ? void 0 : _d.time) {
              if (((_e = data === null || data === void 0 ? void 0 : data.errors) === null || _e === void 0 ? void 0 : _e.time) === 'AfterWorkingHoursPaymentErrorMessage') {
                errorType = {
                  time: _this.props.translations.AfterWorkingHoursPaymentErrorMessage
                };
              }
              _this.setState(_this.intiialState(_this.props));
              _this.props.dispatch({
                type: PAYMENT_VALIDATION,
                payment: {}
              });
              _this.props.authenticate();
            }
            _this.setState({
              paymentSubmitted: false,
              errors: errorType
            });
          }
        });
      } else {
        _this.props.authenticate();
      }
    };
    _this.isLoanInForbearance = function () {
      var _a, _b, _c, _d, _e;
      var modifications = _this.props.layout.modifications;
      var defaultPayments = (((_b = (_a = _this.props.layout) === null || _a === void 0 ? void 0 : _a.paymentModel) === null || _b === void 0 ? void 0 : _b.loan) || {}).defaultPayments;
      var StatusTypeId = modifications === null || modifications === void 0 ? void 0 : modifications.statusTypeId;
      var IsForebearanceOTPVisible = modifications === null || modifications === void 0 ? void 0 : modifications.isForebearanceOTPVisible;
      var forbearacne = StatusTypeId > 0 && IsForebearanceOTPVisible || ((_e = (_d = (_c = _this.props.layout) === null || _c === void 0 ? void 0 : _c.paymentModel) === null || _d === void 0 ? void 0 : _d.loan) === null || _e === void 0 ? void 0 : _e.isLoanInForbearance) || (defaultPayments === null || defaultPayments === void 0 ? void 0 : defaultPayments.route) == "Default" && ((defaultPayments === null || defaultPayments === void 0 ? void 0 : defaultPayments.ruleId) == RuleId.Increased_Payment_Plan || (defaultPayments === null || defaultPayments === void 0 ? void 0 : defaultPayments.ruleId) == RuleId.Reduced_Payment_Plan);
      return forbearacne;
    };
    _this.changeAccount = function (value) {
      var _a, _b, _c;
      var account = (_c = (_b = (_a = _this.props.layout.paymentModel) === null || _a === void 0 ? void 0 : _a.bankAccounts) === null || _b === void 0 ? void 0 : _b.filter(function (s) {
        return parseInt(s.bankAccountType) == parseInt(value);
      })) !== null && _c !== void 0 ? _c : [];
      var selectedbankaccount = account.length > 0 ? account[0] : null;
      var payment = _this.state.payment;
      if (parseInt(value) == 201288) {
        payment.effectiveDate = moment(payment.originalEffectiveDate).format("MM/DD/YYYY");
      }
      if (account.length > 0) {
        payment.bankAccount = selectedbankaccount;
        payment.bankAccountType = value;
        _this.setState({
          payment: payment,
          selectedView: 'PaymentMethodOneTimePayment',
          destinationView: 'PaymentMethodOneTimePayment',
          currentSelectedDate: payment.effectiveDate
        });
      } else {
        payment.bankAccount = {
          "bankAccountType": value
        };
        _this.setState({
          payment: payment,
          bankAccountType: value,
          selectedView: 'PaymentMethodOneTimePayment',
          destinationView: 'PaymentMethodOneTimePayment',
          currentSelectedDate: payment.effectiveDate
        });
      }
    };
    _this.replaceDollarSign = function (value) {
      var _a;
      return (_a = value === null || value === void 0 ? void 0 : value.toString()) === null || _a === void 0 ? void 0 : _a.replace("$", "").replace(",", "");
    };
    _this.minimumPaymentDue = function () {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
      var minimuPaymentDue = (_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.monthlyPaymentAmount;
      if (((_e = (_d = (_c = (_b = _this.props.layout) === null || _b === void 0 ? void 0 : _b.paymentModel) === null || _c === void 0 ? void 0 : _c.loan) === null || _d === void 0 ? void 0 : _d.defaultPayments) === null || _e === void 0 ? void 0 : _e.route) == "Default" && (((_j = (_h = (_g = (_f = _this.props.layout) === null || _f === void 0 ? void 0 : _f.paymentModel) === null || _g === void 0 ? void 0 : _g.loan) === null || _h === void 0 ? void 0 : _h.defaultPayments) === null || _j === void 0 ? void 0 : _j.ruleId) == RuleId.Increased_Payment_Plan || ((_o = (_m = (_l = (_k = _this.props.layout) === null || _k === void 0 ? void 0 : _k.paymentModel) === null || _l === void 0 ? void 0 : _l.loan) === null || _m === void 0 ? void 0 : _m.defaultPayments) === null || _o === void 0 ? void 0 : _o.ruleId) == RuleId.Reduced_Payment_Plan)) {
        (_t = (_s = (_r = (_q = (_p = _this.props.layout) === null || _p === void 0 ? void 0 : _p.paymentModel) === null || _q === void 0 ? void 0 : _q.loan) === null || _r === void 0 ? void 0 : _r.defaultPayments) === null || _s === void 0 ? void 0 : _s.defaultPaymentsDue) === null || _t === void 0 ? void 0 : _t.forEach(function (defpayment) {
          var _a;
          if (((_a = defpayment.paymentType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == "r" && (defpayment.defaultPaymentType == defaulPaymentType.PIT || defpayment.defaultPaymentType == defaulPaymentTypeStr.PIT)) {
            minimuPaymentDue = defpayment.paymentAmountDue;
          }
        });
      }
      return minimuPaymentDue;
    };
    _this.checkPaymentOver = function () {
      var _a, _b;
      var _c = (_a = _this.props.layout) === null || _a === void 0 ? void 0 : _a.currentLoan,
        unpaidPrincipalBalanceAmount = _c.unpaidPrincipalBalanceAmount,
        currentTotalMonthlyPaymentAmount = _c.currentTotalMonthlyPaymentAmount;
      var totalNew = parseFloat(unpaidPrincipalBalanceAmount || 0) - (parseFloat(currentTotalMonthlyPaymentAmount) + (((_b = _this.props.layout.paymentModel) === null || _b === void 0 ? void 0 : _b.pendingPayments) || []).reduce(function (a, b) {
        return a + b.totalDraftAmount;
      }, 0));
      var currentbal = _this.totalDraftAmountFun(true);
      if (currentbal >= totalNew || currentbal >= 99999.99) {
        return true;
      }
      return false;
    };
    _this.disableSubmitButton = function () {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
      var layout = _this.props.layout;
      var accountNumber = (((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.bankAccount) || {}).accountNumber;
      var _o = _this.state,
        edit = _o.edit,
        originalNextPaymentDueDate = _o.originalNextPaymentDueDate;
      var status = (_b = layout.selectedLoanAvailability) === null || _b === void 0 ? void 0 : _b.status;
      var modifications = layout.modifications;
      var isTrialPaymentVisible = (modifications === null || modifications === void 0 ? void 0 : modifications.isTrialPaymentVisible) || (modifications === null || modifications === void 0 ? void 0 : modifications.enablePaymentCoupon);
      var currentTime = moment(layout.localTime);
      var dueDate = moment(layout.currentLoan.nextPaymentDueDate);
      var isDefaultOrDelinquent = ((_e = (_d = (_c = layout.paymentModel) === null || _c === void 0 ? void 0 : _c.loan) === null || _d === void 0 ? void 0 : _d.defaultPayments) === null || _e === void 0 ? void 0 : _e.route) == "Default" || ((_h = (_g = (_f = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _f === void 0 ? void 0 : _f.loan) === null || _g === void 0 ? void 0 : _g.defaultPayments) === null || _h === void 0 ? void 0 : _h.route) == "Delinquent";
      var isLegacy = ((_k = (_j = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _j === void 0 ? void 0 : _j.loan) === null || _k === void 0 ? void 0 : _k.defaultPayments) == null ? true : !isDefaultOrDelinquent;
      var paymentWindow = !edit && (ammountPaymentAhead(status, 2) || (isLegacy ? (_l = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _l === void 0 ? void 0 : _l.pendingPaymentWillMakeLoanCurrentByAmount : false) || (getActiveFeatures(layout.features, "BRMS_Delinquent", layout.whitelisted) ? false : ((_m = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _m === void 0 ? void 0 : _m.numberofPendingPayments) >= 2) || moment(originalNextPaymentDueDate).isAfter(moment(layout.localTime)) && moment([dueDate.year(), dueDate.month(), dueDate.date()]).diff(moment([currentTime.year(), currentTime.month(), dueDate.date()]), 'months', true) > 2);
      return _this.checkPaymentOver() || accountNumber == null || paymentWindow && isTrialPaymentVisible || _this.totalDraftAmountFun() <= 0;
    };
    _this.getStateValue = function (filed) {
      var _a, _b;
      var feesDues = _this.state.payment.feesDues;
      return (_b = (_a = feesDues === null || feesDues === void 0 ? void 0 : feesDues.find(function (s) {
        return s.fieldName == filed;
      })) === null || _a === void 0 ? void 0 : _a.feeAmtField) === null || _b === void 0 ? void 0 : _b.toString();
    };
    _this.getStateValueOriginal = function (filed) {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      var feesDues = _this.state.payment.feesDues;
      if (((_b = (_a = _this.props.location) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.edit) || ((_d = (_c = _this.props.route) === null || _c === void 0 ? void 0 : _c.params) === null || _d === void 0 ? void 0 : _d.edit)) {
        return (_f = (_e = feesDues === null || feesDues === void 0 ? void 0 : feesDues.find(function (s) {
          return s.fieldName == filed;
        })) === null || _e === void 0 ? void 0 : _e.editOrignalFeeAmt) === null || _f === void 0 ? void 0 : _f.toString();
      }
      return (_h = (_g = feesDues === null || feesDues === void 0 ? void 0 : feesDues.find(function (s) {
        return s.fieldName == filed;
      })) === null || _g === void 0 ? void 0 : _g.orignalFeeAmt) === null || _h === void 0 ? void 0 : _h.toString();
    };
    _this.enrolledInPaperLess = function () {
      var selectedLoanPreference = _this.props.layout.selectedLoanPreference;
      var stat = {
        yearEnd: false,
        monthEnd: false
      };
      for (var i = 0; i < selectedLoanPreference.length; i++) {
        if (selectedLoanPreference[i].preferenceTypeCode == 300009 && selectedLoanPreference[i].preferenceCode == 300027) {
          stat.monthEnd = true;
        }
        if (selectedLoanPreference[i].preferenceTypeCode == 300010 && selectedLoanPreference[i].preferenceCode == 300027) {
          stat.yearEnd = true;
        }
      }
      return stat.yearEnd && stat.monthEnd;
    };
    _this.totalFees = function () {
      var _a;
      var bankAccountType = 1..bankAccountType;
      if (_this.state.payment.bankAccount) {
        bankAccountType = _this.state.payment.bankAccount.bankAccountType;
      }
      return ((_a = _this.state.payment.feesDues.filter(function (s) {
        return s.fieldName.indexOf("Income") == -1 && s.fieldName.indexOf("Corportate") == -1;
      })) === null || _a === void 0 ? void 0 : _a.reduce(function (accumulator, currentValue) {
        if (_this.state.payment.paymentType != 201298 && _this.state.payment.paymentType != 201299 && _this.state.payment.paymentType != 201311 && parseInt(bankAccountType) != 201288) {
          return accumulator;
        }
        if (currentValue.fieldName == "debitCardConvenienceFee" && parseInt(bankAccountType) != 201288) {
          return accumulator;
        }
        return accumulator + parseFloat(_this.replaceDollarSign(currentValue.feeAmtField));
      }, 0)) || 0;
    };
    _this.totalDraftAmountFun = function (submit) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
      var deliquentPayment = _this.state.deliquentPayment;
      if (((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.paymentType) == 1000145 || ((_b = _this.state.payment) === null || _b === void 0 ? void 0 : _b.paymentType) == 1000146) {
        return parseFloat(_this.replaceDollarSign((_c = _this.state.payment) === null || _c === void 0 ? void 0 : _c.forbearanceAmount)) || 0;
      }
      var totalDraftAmount = (parseFloat(_this.totalFees()) || 0) + (parseFloat(_this.replaceDollarSign((_d = _this.state.payment) === null || _d === void 0 ? void 0 : _d.additionalEscrowAmount)) || 0) + (parseFloat(_this.replaceDollarSign((_e = _this.state.payment) === null || _e === void 0 ? void 0 : _e.additionalPrincipalAmount)) || 0) + (((_f = _this.props.layout.paymentModel) === null || _f === void 0 ? void 0 : _f.mustMakeDelinquentPayment) && _this.props.layout.paymentModel.numberofPendingPayments == 0 ? parseFloat(_this.replaceDollarSign((_g = _this.state.payment) === null || _g === void 0 ? void 0 : _g.delinquentPaymentAmount)) || 0 : parseFloat(_this.replaceDollarSign((_h = _this.state.payment) === null || _h === void 0 ? void 0 : _h.monthlyPaymentAmount)) || 0);
      if (deliquentPayment) {
        totalDraftAmount = (parseFloat(_this.totalFees()) || 0) + (parseFloat(_this.replaceDollarSign((_j = _this.state.payment) === null || _j === void 0 ? void 0 : _j.additionalEscrowAmount)) || 0) + (parseFloat(_this.replaceDollarSign((_k = _this.state.payment) === null || _k === void 0 ? void 0 : _k.additionalPrincipalAmount)) || 0) + (parseFloat(_this.replaceDollarSign((_l = _this.state.payment) === null || _l === void 0 ? void 0 : _l.monthlyPaymentAmount)) || 0) + (parseFloat(_this.replaceDollarSign((_m = _this.state.payment) === null || _m === void 0 ? void 0 : _m.delinquentPaymentAmount)) || 0);
      }
      if (((_o = _this.state.payment) === null || _o === void 0 ? void 0 : _o.paymentType) == 201311) {
        totalDraftAmount = (parseFloat(_this.totalFees()) || 0) + (parseFloat(_this.replaceDollarSign((_p = _this.state.payment) === null || _p === void 0 ? void 0 : _p.additionalEscrowAmount)) || 0) + (parseFloat(_this.replaceDollarSign((_q = _this.state.payment) === null || _q === void 0 ? void 0 : _q.additionalPrincipalAmount)) || 0) + (parseFloat((_s = (_r = _this.state.payment) === null || _r === void 0 ? void 0 : _r.delinquentPayments) === null || _s === void 0 ? void 0 : _s.filter(function (s) {
          return s.selected && !s.paid;
        }).reduce(function (a, o) {
          return a += parseFloat(o.paymentAmount);
        }, 0)) || 0);
      }
      // add principle
      if (((_t = _this.state.payment) === null || _t === void 0 ? void 0 : _t.paymentType) == 201297) {
        totalDraftAmount = parseFloat(_this.replaceDollarSign((_u = _this.state.payment) === null || _u === void 0 ? void 0 : _u.additionalPrincipalAmount)) || 0;
      }
      // add escrow
      if (((_v = _this.state.payment) === null || _v === void 0 ? void 0 : _v.paymentType) == 201299) {
        totalDraftAmount = (parseFloat(_this.totalFees()) || 0) + (parseFloat(_this.replaceDollarSign((_w = _this.state.payment) === null || _w === void 0 ? void 0 : _w.additionalEscrowAmount)) || 0);
      }
      // ach
      if (((_x = _this.state.payment) === null || _x === void 0 ? void 0 : _x.paymentType) == 201309) {
        totalDraftAmount = (parseFloat(_this.replaceDollarSign((_y = _this.state.payment) === null || _y === void 0 ? void 0 : _y.additionalPrincipalAmount)) || 0) + (parseFloat(_this.replaceDollarSign((_z = _this.state.payment) === null || _z === void 0 ? void 0 : _z.monthlyPaymentAmount)) || 0);
      }
      //Trial Payment
      if (((_0 = _this.state.payment) === null || _0 === void 0 ? void 0 : _0.paymentType) == 201296) {
        totalDraftAmount = parseFloat(_this.replaceDollarSign((_1 = _this.state.payment) === null || _1 === void 0 ? void 0 : _1.monthlyPaymentAmount)) || 0;
      }
      return totalDraftAmount;
    };
    _this.separateCommas = function (val) {
      var num = val === null || val === void 0 ? void 0 : val.replace(/,/gi, "");
      var num2 = num === null || num === void 0 ? void 0 : num.replace(/\d(?=(?:\d{3})+$)/g, '$&,');
      return num2;
    };
    _this.delinquentValue = function () {
      var _a, _b, _c, _d;
      if (((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.paymentType) == 201311) {
        return (parseFloat((_c = (_b = _this.state.payment) === null || _b === void 0 ? void 0 : _b.delinquentPayments) === null || _c === void 0 ? void 0 : _c.filter(function (s) {
          return s.selected && !s.paid;
        }).reduce(function (a, o) {
          return a += parseFloat(o.paymentAmount);
        }, 0)) || 0).toFixed(2);
      }
      return parseFloat(parseFloat(_this.replaceDollarSign(_this.state.payment.delinquentPaymentAmount)) + parseFloat(_this.replaceDollarSign((_d = _this.state.payment) === null || _d === void 0 ? void 0 : _d.delinquentMonthlyPaymentAmount))).toFixed(2);
    };
    _this.getState = function () {
      return _this.state;
    };
    _this.monthlyPayment = function () {
      var _a, _b, _c;
      if (((_c = (_b = (_a = _this.props.layout.paymentModel) === null || _a === void 0 ? void 0 : _a.payment) === null || _b === void 0 ? void 0 : _b.delinquentPayments) === null || _c === void 0 ? void 0 : _c.length) > 0) {
        return 201311;
      }
      return 201298;
    };
    _this.state = _this.intiialState(props);
    if (props.navigation && props.layout.mobile) {
      var that_1 = _this;
      props.navigation.addListener('focus', function () {
        var _a, _b, _c;
        var newBankListWithPayments = ((_c = (_b = (_a = _this.props.layout) === null || _a === void 0 ? void 0 : _a.paymentModel) === null || _b === void 0 ? void 0 : _b.bankAccounts) === null || _c === void 0 ? void 0 : _c.filter(function (s) {
          return !s.newlyAdded;
        })) || [];
        _this.props.dispatch({
          type: NACHA_BANKACCOUNT,
          paymentModel: __assign(__assign({}, _this.props.layout.paymentModel), {
            bankAccounts: newBankListWithPayments
          })
        });
        that_1.setState({
          isMounted: false,
          payment: __assign(__assign({}, _this.state.payment), {
            monthlyPaymentAmount: "0.00"
          })
        });
      });
    }
    return _this;
  }
  OneTimePaymentNative.prototype.componentDidMount = function () {
    var _this = this;
    if (Platform.OS !== 'web') {
      this.unsubscribeBlur = this.props.navigation.addListener('blur', function () {
        var _a, _b;
        if (((_b = (_a = _this.props.layout) === null || _a === void 0 ? void 0 : _a.paymentModel) === null || _b === void 0 ? void 0 : _b.selectedView) == "PaymentMethodOneTimePayment") {
          _this.props.dispatch({
            type: NACHA_BANKACCOUNT,
            paymentModel: __assign(__assign({}, _this.props.layout.paymentModel), {
              selectedView: undefined
            })
          });
        }
        _this.setState({
          open: false
        });
      });
    }
  };
  OneTimePaymentNative.getDerivedStateFromProps = function (props, state) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93;
    var route = props.route;
    var path = props.layout.mobile ? route.pathname : window.location.pathname;
    var achExist = (_c = (_b = (_a = props.layout) === null || _a === void 0 ? void 0 : _a.paymentModel) === null || _b === void 0 ? void 0 : _b.pendingPayments) === null || _c === void 0 ? void 0 : _c.find(function (s) {
      return s.paymentType == 201309;
    });
    if (((_d = state.payment) === null || _d === void 0 ? void 0 : _d.monthlyPaymentAmount) == "0.00" && props.layout.currentLoan != null && props.layout.paymentModel != null && (!state.isMounted || !state.isMountedBank) || path != state.pathname) {
      var modifications = props.layout.modifications;
      var StatusTypeId = modifications === null || modifications === void 0 ? void 0 : modifications.statusTypeId;
      var IsForebearanceOTPVisible = modifications === null || modifications === void 0 ? void 0 : modifications.isForebearanceOTPVisible;
      var isTrialPaymentVisible_1 = (modifications === null || modifications === void 0 ? void 0 : modifications.isTrialPaymentVisible) || (modifications === null || modifications === void 0 ? void 0 : modifications.enablePaymentCoupon);
      var forbearacne_1 = StatusTypeId > 0 && IsForebearanceOTPVisible || ((_e = props.layout.currentLoan) === null || _e === void 0 ? void 0 : _e.isLoanInForbearance) || ((_j = (_h = (_g = (_f = props.layout) === null || _f === void 0 ? void 0 : _f.paymentModel) === null || _g === void 0 ? void 0 : _g.loan) === null || _h === void 0 ? void 0 : _h.defaultPayments) === null || _j === void 0 ? void 0 : _j.route) == "Default" && (((_o = (_m = (_l = (_k = props.layout) === null || _k === void 0 ? void 0 : _k.paymentModel) === null || _l === void 0 ? void 0 : _l.loan) === null || _m === void 0 ? void 0 : _m.defaultPayments) === null || _o === void 0 ? void 0 : _o.ruleId) == RuleId.Increased_Payment_Plan || ((_s = (_r = (_q = (_p = props.layout) === null || _p === void 0 ? void 0 : _p.paymentModel) === null || _q === void 0 ? void 0 : _q.loan) === null || _r === void 0 ? void 0 : _r.defaultPayments) === null || _s === void 0 ? void 0 : _s.ruleId) == RuleId.Reduced_Payment_Plan);
      var edit = (_u = (_t = props.location) === null || _t === void 0 ? void 0 : _t.state) === null || _u === void 0 ? void 0 : _u.edit;
      if ((_v = props.route) === null || _v === void 0 ? void 0 : _v.params) {
        edit = (_x = (_w = props.route) === null || _w === void 0 ? void 0 : _w.params) === null || _x === void 0 ? void 0 : _x.edit;
      }
      // SVT-36313 - preventing PopUp while changing the langauge (&& state.isMountedBank !== undefined)
      // based on the device type.
      var show = props.layout.mobile ? props.isOtp && !edit && (((_z = (_y = props.layout.paymentModel) === null || _y === void 0 ? void 0 : _y.pendingPayments) === null || _z === void 0 ? void 0 : _z.filter(function (s) {
        return s.paymentType == 201298 || s.paymentType == 201309;
      }).length) > 0 && moment((_0 = props.layout.currentLoan) === null || _0 === void 0 ? void 0 : _0.nextPaymentDueDate).month() >= moment(props.layout.localTime).month() || moment((_1 = props.layout.currentLoan) === null || _1 === void 0 ? void 0 : _1.nextPaymentDueDate) > moment(props.layout.localTime)) && !isTrialPaymentVisible_1 && !forbearacne_1 && !((_3 = (_2 = props.layout) === null || _2 === void 0 ? void 0 : _2.paymentModel) === null || _3 === void 0 ? void 0 : _3.mustMakeDelinquentPayment) && !state.isMounted && state.isMountedBank !== undefined : props.isOtp && !edit && (((_5 = (_4 = props.layout.paymentModel) === null || _4 === void 0 ? void 0 : _4.pendingPayments) === null || _5 === void 0 ? void 0 : _5.filter(function (s) {
        return s.paymentType == 201298 || s.paymentType == 201309;
      }).length) > 0 && moment((_6 = props.layout.currentLoan) === null || _6 === void 0 ? void 0 : _6.nextPaymentDueDate).month() >= moment(props.layout.localTime).month() || moment((_7 = props.layout.currentLoan) === null || _7 === void 0 ? void 0 : _7.nextPaymentDueDate) > moment(props.layout.localTime)) && !isTrialPaymentVisible_1 && !forbearacne_1 && !((_9 = (_8 = props.layout) === null || _8 === void 0 ? void 0 : _8.paymentModel) === null || _9 === void 0 ? void 0 : _9.mustMakeDelinquentPayment) && !state.isMounted;
      var status_1 = (_10 = props.layout.selectedLoanAvailability) === null || _10 === void 0 ? void 0 : _10.status;
      var currentTime = moment(props.layout.localTime);
      var dueDate = moment(props.layout.currentLoan.nextPaymentDueDate);
      var isDefaultOrDelinquent = ((_13 = (_12 = (_11 = props.layout.paymentModel) === null || _11 === void 0 ? void 0 : _11.loan) === null || _12 === void 0 ? void 0 : _12.defaultPayments) === null || _13 === void 0 ? void 0 : _13.route) == "Default" || ((_17 = (_16 = (_15 = (_14 = props.layout) === null || _14 === void 0 ? void 0 : _14.paymentModel) === null || _15 === void 0 ? void 0 : _15.loan) === null || _16 === void 0 ? void 0 : _16.defaultPayments) === null || _17 === void 0 ? void 0 : _17.route) == "Delinquent";
      var isLegacy = ((_20 = (_19 = (_18 = props.layout) === null || _18 === void 0 ? void 0 : _18.paymentModel) === null || _19 === void 0 ? void 0 : _19.loan) === null || _20 === void 0 ? void 0 : _20.defaultPayments) == null ? true : !isDefaultOrDelinquent;
      var paymentWindow_1 = !edit && (ammountPaymentAhead(status_1, 2) || (isLegacy ? (_22 = (_21 = props.layout) === null || _21 === void 0 ? void 0 : _21.paymentModel) === null || _22 === void 0 ? void 0 : _22.pendingPaymentWillMakeLoanCurrentByAmount : false) || (getActiveFeatures(props.layout.features, "BRMS_Delinquent", props.layout.whitelisted) ? false : ((_24 = (_23 = props.layout) === null || _23 === void 0 ? void 0 : _23.paymentModel) === null || _24 === void 0 ? void 0 : _24.numberofPendingPayments) >= 2) || moment((_25 = props.layout.currentLoan) === null || _25 === void 0 ? void 0 : _25.originalNextPaymentDueDate).isAfter(moment(props.layout.localTime)) && moment([dueDate.year(), dueDate.month(), dueDate.date()]).diff(moment([currentTime.year(), currentTime.month(), dueDate.date()]), 'months', true) > 2);
      Object.keys(((_27 = (_26 = props.layout) === null || _26 === void 0 ? void 0 : _26.paymentModel) === null || _27 === void 0 ? void 0 : _27.payment) || {}).map(function (s) {
        if ("suspenseAmount,monthlyPaymentAmount,totalFeesAmount,additionalEscrowAmount,delinquentPaymentAmount,additionalPrincipalAmount".indexOf(s) > -1) {
          props.layout.paymentModel.payment[s] = isNaN(props.layout.paymentModel.payment[s]) ? 0.00 : parseFloat(props.layout.paymentModel.payment[s]).toFixed(2);
        }
      });
      if (((_28 = props.layout.paymentModel) === null || _28 === void 0 ? void 0 : _28.payment) && ((_30 = (_29 = props.layout.paymentModel) === null || _29 === void 0 ? void 0 : _29.payment) === null || _30 === void 0 ? void 0 : _30.feesDues.length) > 0) {
        props.layout.paymentModel.payment.feesDues.forEach(function (s) {
          s.feeAmtField = isNaN(s.feeAmtField) ? 0.00 : parseFloat(s.feeAmtField).toFixed(2);
        });
      }
      if (!edit && ((_34 = (_33 = (_32 = (_31 = props.layout) === null || _31 === void 0 ? void 0 : _31.paymentModel) === null || _32 === void 0 ? void 0 : _32.payment) === null || _33 === void 0 ? void 0 : _33.feesDues) === null || _34 === void 0 ? void 0 : _34.length) > 0) {
        var oFee = props.layout.paymentModel.payment.feesDues.find(function (w) {
          return w.fieldName == "otherFeesDue";
        });
        var oFeeIndex = props.layout.paymentModel.payment.feesDues.findIndex(function (w) {
          return w.fieldName == "otherFeesDue";
        });
        if (oFee) {
          oFee.feeAmtField = "0.00";
          props.layout.paymentModel.payment.feesDues.splice(oFeeIndex, 1, oFee);
        }
      }
      var replaceDollarSign_1 = function (value) {
        var _a;
        return (_a = value === null || value === void 0 ? void 0 : value.toString()) === null || _a === void 0 ? void 0 : _a.replace("$", "").replace(",", "");
      };
      var totalFees_1 = function () {
        var _a, _b;
        var bankAccountType = state.payment.bankAccount.bankAccountType;
        return (_b = (_a = state.payment.feesDues) === null || _a === void 0 ? void 0 : _a.reduce(function (accumulator, currentValue) {
          if (state.payment.paymentType != 201298 && state.payment.paymentType != 201299 && state.payment.paymentType != 201311 && parseInt(bankAccountType) != 201288) {
            return accumulator;
          }
          if (currentValue.fieldName == "debitCardConvenienceFee" && parseInt(bankAccountType) != 201288) {
            return accumulator;
          }
          return accumulator + parseFloat(replaceDollarSign_1(currentValue.feeAmtField));
        }, 0)) !== null && _b !== void 0 ? _b : 0;
      };
      var minimumPaymentDue = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        var minimuPaymentDue = (_a = state.payment) === null || _a === void 0 ? void 0 : _a.monthlyPaymentAmount;
        if (((_e = (_d = (_c = (_b = props.layout) === null || _b === void 0 ? void 0 : _b.paymentModel) === null || _c === void 0 ? void 0 : _c.loan) === null || _d === void 0 ? void 0 : _d.defaultPayments) === null || _e === void 0 ? void 0 : _e.route) == "Default" && (((_j = (_h = (_g = (_f = props.layout) === null || _f === void 0 ? void 0 : _f.paymentModel) === null || _g === void 0 ? void 0 : _g.loan) === null || _h === void 0 ? void 0 : _h.defaultPayments) === null || _j === void 0 ? void 0 : _j.ruleId) == RuleId.Increased_Payment_Plan || ((_o = (_m = (_l = (_k = props.layout) === null || _k === void 0 ? void 0 : _k.paymentModel) === null || _l === void 0 ? void 0 : _l.loan) === null || _m === void 0 ? void 0 : _m.defaultPayments) === null || _o === void 0 ? void 0 : _o.ruleId) == RuleId.Reduced_Payment_Plan)) {
          (_t = (_s = (_r = (_q = (_p = props.layout) === null || _p === void 0 ? void 0 : _p.paymentModel) === null || _q === void 0 ? void 0 : _q.loan) === null || _r === void 0 ? void 0 : _r.defaultPayments) === null || _s === void 0 ? void 0 : _s.defaultPaymentsDue) === null || _t === void 0 ? void 0 : _t.forEach(function (defpayment) {
            var _a;
            if (((_a = defpayment === null || defpayment === void 0 ? void 0 : defpayment.paymentType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == "r" && (defpayment.defaultPaymentType == defaulPaymentType.PIT || defpayment.defaultPaymentType == defaulPaymentTypeStr.PIT)) {
              minimuPaymentDue = defpayment.paymentAmountDue;
            }
          });
        }
        return minimuPaymentDue;
      };
      var paymentType = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        // return 1000146;
        if (!props.isOtp) {
          return 201309;
        } else {
          if (((_c = (_b = (_a = props.layout.paymentModel) === null || _a === void 0 ? void 0 : _a.payment) === null || _b === void 0 ? void 0 : _b.delinquentPayments) === null || _c === void 0 ? void 0 : _c.length) > 1) {
            if ((_f = (_e = (_d = props.layout.paymentModel) === null || _d === void 0 ? void 0 : _d.payment) === null || _e === void 0 ? void 0 : _e.delinquentPayments) === null || _f === void 0 ? void 0 : _f.some(function (s) {
              return !s.paid;
            })) {
              return 201311;
            } else {
              return 201299;
            }
          }
          if (isTrialPaymentVisible_1) {
            return 201296;
          } else {
            if (paymentWindow_1) {
              if (!(((_h = (_g = props.layout) === null || _g === void 0 ? void 0 : _g.currentLoan) === null || _h === void 0 ? void 0 : _h.escrowFlag) || totalFees_1() > 0)) {
                return 201297;
              } else {
                return 201299;
              }
            } else {
              if (forbearacne_1) {
                var payRuleId = (_m = (_l = (_k = (_j = props.layout) === null || _j === void 0 ? void 0 : _j.paymentModel) === null || _k === void 0 ? void 0 : _k.loan) === null || _l === void 0 ? void 0 : _l.defaultPayments) === null || _m === void 0 ? void 0 : _m.ruleId;
                if (payRuleId == RuleId.Reduced_Payment_Plan || payRuleId == RuleId.Increased_Payment_Plan) {
                  return 1000146;
                } else {
                  return 1000145;
                }
              } else {
                return (_p = (_o = props.layout.paymentModel) === null || _o === void 0 ? void 0 : _o.payment) === null || _p === void 0 ? void 0 : _p.paymentType;
              }
            }
          }
        }
      };
      var achnext = function () {
        var _a, _b;
        if (props.isOtp) {
          return moment((_b = (_a = props.layout.paymentModel) === null || _a === void 0 ? void 0 : _a.payment) === null || _b === void 0 ? void 0 : _b.effectiveDate);
        } else {
          return state.effectiveDate;
        }
      };
      var editPayment = props.layout.mobile ? __assign(__assign({}, (_36 = (_35 = props.route) === null || _35 === void 0 ? void 0 : _35.params) === null || _36 === void 0 ? void 0 : _36.payment), {
        feesHelperMethod: (_39 = (_38 = (_37 = props.layout) === null || _37 === void 0 ? void 0 : _37.paymentModel) === null || _38 === void 0 ? void 0 : _38.payment) === null || _39 === void 0 ? void 0 : _39.feesHelperMethod
      }) : __assign(__assign({}, (_41 = (_40 = props.location) === null || _40 === void 0 ? void 0 : _40.state) === null || _41 === void 0 ? void 0 : _41.payment), {
        feesHelperMethod: props.layout.paymentModel.payment.feesHelperMethod
      });
      var incomingPayment = edit ? editPayment : !props.isOtp && achExist ? achExist : __assign(__assign(__assign({}, state.payment), props.layout.paymentModel.payment), {
        bankAccount: __assign(__assign({}, (_43 = (_42 = props.layout.paymentModel) === null || _42 === void 0 ? void 0 : _42.payment) === null || _43 === void 0 ? void 0 : _43.bankAccount), {
          bankAccountType: ((_46 = (_45 = (_44 = props.layout.paymentModel) === null || _44 === void 0 ? void 0 : _44.payment) === null || _45 === void 0 ? void 0 : _45.bankAccount) === null || _46 === void 0 ? void 0 : _46.bankAccountType) != 201288 ? (_49 = (_48 = (_47 = props.layout.paymentModel) === null || _47 === void 0 ? void 0 : _47.payment) === null || _48 === void 0 ? void 0 : _48.bankAccount) === null || _49 === void 0 ? void 0 : _49.bankAccountType : 201286
        }),
        bankAccountType: ((_52 = (_51 = (_50 = props.layout.paymentModel) === null || _50 === void 0 ? void 0 : _50.payment) === null || _51 === void 0 ? void 0 : _51.bankAccount) === null || _52 === void 0 ? void 0 : _52.bankAccountType) && ((_55 = (_54 = (_53 = props.layout.paymentModel) === null || _53 === void 0 ? void 0 : _53.payment) === null || _54 === void 0 ? void 0 : _54.bankAccount) === null || _55 === void 0 ? void 0 : _55.bankAccountType) != 201288 ? (_58 = (_57 = (_56 = props.layout.paymentModel) === null || _56 === void 0 ? void 0 : _56.payment) === null || _57 === void 0 ? void 0 : _57.bankAccount) === null || _58 === void 0 ? void 0 : _58.bankAccountType : 201286,
        paymentType: paymentType(),
        totalDraftAmount: paymentWindow_1 ? 0 : (_60 = (_59 = props.layout.paymentModel) === null || _59 === void 0 ? void 0 : _59.payment) === null || _60 === void 0 ? void 0 : _60.totalDraftAmount,
        dueDate: (_61 = props.layout.currentLoan) === null || _61 === void 0 ? void 0 : _61.nextPaymentDueDate,
        effectiveDate: achnext(),
        // defaultPayments: props.layout.paymentModel?.payment?.loan?.defaultPayments,
        forbearanceAmount: minimumPaymentDue()
      });
      if (!edit && ((_62 = incomingPayment === null || incomingPayment === void 0 ? void 0 : incomingPayment.delinquentPayments) === null || _62 === void 0 ? void 0 : _62.length) > 1) {
        var lastUnselectedIndex = null;
        incomingPayment.delinquentPayments.sort(function (a, b) {
          return new Date(a.dueDate) - new Date(b.dueDate);
        });
        for (var i = 0; i < incomingPayment.delinquentPayments.length; i++) {
          if (!incomingPayment.delinquentPayments[i].selected && ((_64 = (_63 = incomingPayment.delinquentPayments) === null || _63 === void 0 ? void 0 : _63[i - 1]) === null || _64 === void 0 ? void 0 : _64.status) == 'Pending') {
            lastUnselectedIndex = i;
            break;
          }
        }
        if ((incomingPayment === null || incomingPayment === void 0 ? void 0 : incomingPayment.delinquentPayments) !== null && lastUnselectedIndex > 0 && lastUnselectedIndex < ((_65 = incomingPayment.delinquentPayments) === null || _65 === void 0 ? void 0 : _65.length)) {
          incomingPayment.delinquentPayments[lastUnselectedIndex].selected = true;
        }
      }
      var setPayment = __assign(__assign({}, props.layout), {
        paymentModel: __assign(__assign({}, props.layout.paymentModel), {
          payment: incomingPayment
        })
      });
      if (props.testFixture) {
        props.testFixture(setPayment);
      }
      var getLatestPaidDueDate = function (payments) {
        var _a;
        var latestDueDate = (payments === null || payments === void 0 ? void 0 : payments.length) > 0 ? (_a = payments[0]) === null || _a === void 0 ? void 0 : _a.dueDate : null;
        for (var _i = 0, payments_1 = payments; _i < payments_1.length; _i++) {
          var payment = payments_1[_i];
          if (payment.paid && (!latestDueDate || payment.dueDate > latestDueDate)) {
            latestDueDate = payment.dueDate;
          }
        }
        return moment(latestDueDate).add('month', 1);
      };
      var updatedDate = edit ? (_70 = props.layout.mobile ? (_67 = (_66 = props.route) === null || _66 === void 0 ? void 0 : _66.params) === null || _67 === void 0 ? void 0 : _67.payment : (_69 = (_68 = props.location) === null || _68 === void 0 ? void 0 : _68.state) === null || _69 === void 0 ? void 0 : _69.payment) === null || _70 === void 0 ? void 0 : _70.effectiveDate : state.currentSelectedDate;
      return __assign(__assign({}, state), {
        currentSelectedDate: updatedDate,
        open: show,
        pathname: path,
        modalType: "pendingPayments",
        lateChargeGraceEndDate: (_71 = props.layout.currentLoan) === null || _71 === void 0 ? void 0 : _71.lateChargeGraceEndDate,
        graceDays: (_72 = props.layout.currentLoan) === null || _72 === void 0 ? void 0 : _72.graceDays,
        pendingPaymentDate: ((_74 = (_73 = props.layout.paymentModel) === null || _73 === void 0 ? void 0 : _73.pendingPayments) === null || _74 === void 0 ? void 0 : _74.find(function (s) {
          return s.paymentType == 201298 || s.paymentType == 201311;
        })) ? (_77 = (_76 = (_75 = props.layout.paymentModel) === null || _75 === void 0 ? void 0 : _75.pendingPayments) === null || _76 === void 0 ? void 0 : _76.filter(function (s) {
          return s.paymentType == 201298 || s.paymentType == 201311;
        })) === null || _77 === void 0 ? void 0 : _77.sort(function (a, b) {
          return new Date(a.dueDate) - new Date(b.dueDate);
        })[0] : {},
        lastEffectiveDate: ((_79 = (_78 = props.layout.paymentModel) === null || _78 === void 0 ? void 0 : _78.pendingPayments) === null || _79 === void 0 ? void 0 : _79.find(function (s) {
          return s.paymentType == 201298 || s.paymentType == 201311;
        })) ? (_82 = (_81 = (_80 = props.layout.paymentModel) === null || _80 === void 0 ? void 0 : _80.pendingPayments) === null || _81 === void 0 ? void 0 : _81.filter(function (s) {
          return s.paymentType == 201298 || s.paymentType == 201311;
        })) === null || _82 === void 0 ? void 0 : _82.sort(function (a, b) {
          return new Date(b.effectiveDate) - new Date(a.effectiveDate);
        })[0] : {},
        isMounted: ((_84 = (_83 = props.layout.paymentModel) === null || _83 === void 0 ? void 0 : _83.payment) === null || _84 === void 0 ? void 0 : _84.monthlyPaymentAmount) != undefined,
        isMountedBank: true,
        edit: edit || false,
        originalNextPaymentDueDate: (_85 = props.layout.currentLoan) === null || _85 === void 0 ? void 0 : _85.originalNextPaymentDueDate,
        nextPaymentDueDate: incomingPayment.delinquentPayments.length > 0 ? getLatestPaidDueDate(incomingPayment.delinquentPayments) : (_86 = props.layout.currentLoan) === null || _86 === void 0 ? void 0 : _86.nextPaymentDueDate,
        canMakePrincipleReduction: moment((_87 = props.layout.currentLoan) === null || _87 === void 0 ? void 0 : _87.originalNextPaymentDueDate).year() > moment(props.layout.localTime).year() || moment((_88 = props.layout.currentLoan) === null || _88 === void 0 ? void 0 : _88.originalNextPaymentDueDate).month() > moment(props.layout.localTime).month(),
        canMakeAdditionalAmounts: ((_90 = (_89 = props.layout) === null || _89 === void 0 ? void 0 : _89.currentLoan) === null || _90 === void 0 ? void 0 : _90.delinquentPaymentCount) <= 1 || (isLegacy ? (_92 = (_91 = props.layout) === null || _91 === void 0 ? void 0 : _91.paymentModel) === null || _92 === void 0 ? void 0 : _92.pendingPaymentWillMakeLoanCurrentByAmount : false),
        page: !props.isOtp && achExist != undefined && !edit ? "confirm" : state.page == "bank" ? "bank" : "pay",
        achExist: achExist != undefined && !props.isOtp,
        openedTerms: achExist != undefined && !props.isOtp || edit || false,
        payment: incomingPayment,
        confirmModalOpen: (_93 = state.confirmModalOpen) !== null && _93 !== void 0 ? _93 : false
      });
    }
    return __assign(__assign({}, state), {
      achExist: achExist != undefined && !props.isOtp
    });
  };
  OneTimePaymentNative.prototype.render = function () {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
    var _0 = this.props,
      translations = _0.translations,
      layout = _0.layout,
      paymentType = _0.paymentType,
      matches = _0.matches,
      disableDebit = _0.disableDebit,
      route = _0.route;
    var _1 = ((_a = this.state.payment) === null || _a === void 0 ? void 0 : _a.bankAccount) || {},
      _2 = _1.bankAccountType,
      bankAccountType = _2 === void 0 ? 201286 : _2,
      bankAccountId = _1.bankAccountId,
      routingTransitNumber = _1.routingTransitNumber,
      accountNumber = _1.accountNumber,
      accountName = _1.accountName,
      unmaskedAccountNumber = _1.unmaskedAccountNumber;
    var _3 = this.state,
      deliquentPayment = _3.deliquentPayment,
      displayedConfirmationId = _3.displayedConfirmationId,
      errors = _3.errors,
      canMakePrincipleReduction = _3.canMakePrincipleReduction,
      canMakeAdditionalAmounts = _3.canMakeAdditionalAmounts,
      nextPaymentDueDate = _3.nextPaymentDueDate,
      edit = _3.edit,
      tabProgression = _3.tabProgression,
      pendingPaymentDate = _3.pendingPaymentDate,
      originalNextPaymentDueDate = _3.originalNextPaymentDueDate,
      openDebit = _3.openDebit,
      achExist = _3.achExist,
      payment = _3.payment,
      graceDays = _3.graceDays;
    var status = (_b = layout.selectedLoanAvailability) === null || _b === void 0 ? void 0 : _b.status;
    var modifications = layout.modifications,
      paymentModel = layout.paymentModel;
    var isTrialPaymentVisible = (modifications === null || modifications === void 0 ? void 0 : modifications.isTrialPaymentVisible) || (modifications === null || modifications === void 0 ? void 0 : modifications.enablePaymentCoupon);
    var currentTime = moment(layout.localTime);
    var dueDate = moment(layout.currentLoan.nextPaymentDueDate);
    var isDefaultOrDelinquent = ((_e = (_d = (_c = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _c === void 0 ? void 0 : _c.loan) === null || _d === void 0 ? void 0 : _d.defaultPayments) === null || _e === void 0 ? void 0 : _e.route) == "Default" || ((_h = (_g = (_f = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _f === void 0 ? void 0 : _f.loan) === null || _g === void 0 ? void 0 : _g.defaultPayments) === null || _h === void 0 ? void 0 : _h.route) == "Delinquent";
    var isLegacy = ((_k = (_j = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _j === void 0 ? void 0 : _j.loan) === null || _k === void 0 ? void 0 : _k.defaultPayments) == null ? true : !isDefaultOrDelinquent;
    var numberofPostedScheduledPendingPayments = (_m = (_l = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _l === void 0 ? void 0 : _l.pendingPaymentsPostedWithoutFailedStatus) === null || _m === void 0 ? void 0 : _m.length;
    //  let paymentWindow = !edit && (ammountPaymentAhead(status, 2) || (getActiveFeatures(layout.features, `BRMS_Delinquent`, layout.whitelisted) ? false: layout?.paymentModel?.numberofPendingPayments >= 2) || (moment(originalNextPaymentDueDate).isAfter(moment(layout.localTime)) && moment([dueDate.year(), dueDate.month(), dueDate.date()]).diff(moment([currentTime.year(), currentTime.month(), dueDate.date()]), 'months', true) > 2))
    var paymentWindow = !edit && (ammountPaymentAhead(status, 2) || (isLegacy ? (_o = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _o === void 0 ? void 0 : _o.pendingPaymentWillMakeLoanCurrentByAmount : false) || (getActiveFeatures(layout.features, "BRMS_Delinquent", layout.whitelisted) ? false : ((_p = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _p === void 0 ? void 0 : _p.numberofPendingPayments) >= 2) || moment(originalNextPaymentDueDate).isAfter(moment(layout.localTime)) && moment([dueDate.year(), dueDate.month(), dueDate.date()]).diff(moment([currentTime.year(), currentTime.month(), dueDate.date()]), 'months', true) > 2);
    var isOtp = this.props.isOtp;
    if ((_q = route === null || route === void 0 ? void 0 : route.params) === null || _q === void 0 ? void 0 : _q.isOtp) {
      isOtp = true;
    }
    var getMinimumPaymentDue = function () {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
      var minimuPaymentDue = (_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.monthlyPaymentAmount;
      if (((_d = (_c = (_b = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _b === void 0 ? void 0 : _b.loan) === null || _c === void 0 ? void 0 : _c.defaultPayments) === null || _d === void 0 ? void 0 : _d.route) == "Default" && (((_g = (_f = (_e = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _e === void 0 ? void 0 : _e.loan) === null || _f === void 0 ? void 0 : _f.defaultPayments) === null || _g === void 0 ? void 0 : _g.ruleId) == RuleId.Increased_Payment_Plan || ((_k = (_j = (_h = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _h === void 0 ? void 0 : _h.loan) === null || _j === void 0 ? void 0 : _j.defaultPayments) === null || _k === void 0 ? void 0 : _k.ruleId) == RuleId.Reduced_Payment_Plan)) {
        (_p = (_o = (_m = (_l = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _l === void 0 ? void 0 : _l.loan) === null || _m === void 0 ? void 0 : _m.defaultPayments) === null || _o === void 0 ? void 0 : _o.defaultPaymentsDue) === null || _p === void 0 ? void 0 : _p.forEach(function (defpayment) {
          var _a;
          if (((_a = defpayment === null || defpayment === void 0 ? void 0 : defpayment.paymentType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == "r" && (defpayment.defaultPaymentType == defaulPaymentType.PIT || defpayment.defaultPaymentType == defaulPaymentTypeStr.PIT)) {
            minimuPaymentDue = defpayment.paymentAmountDue;
          }
        });
      }
      return minimuPaymentDue;
    };
    var getMinimumPaymentDueDate = function () {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
      var paymentDueDate = _this.state.nextPaymentDueDate;
      if (((_c = (_b = (_a = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _a === void 0 ? void 0 : _a.loan) === null || _b === void 0 ? void 0 : _b.defaultPayments) === null || _c === void 0 ? void 0 : _c.route) == "Default" && (((_f = (_e = (_d = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _d === void 0 ? void 0 : _d.loan) === null || _e === void 0 ? void 0 : _e.defaultPayments) === null || _f === void 0 ? void 0 : _f.ruleId) == RuleId.Increased_Payment_Plan || ((_j = (_h = (_g = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _g === void 0 ? void 0 : _g.loan) === null || _h === void 0 ? void 0 : _h.defaultPayments) === null || _j === void 0 ? void 0 : _j.ruleId) == RuleId.Reduced_Payment_Plan)) {
        (_o = (_m = (_l = (_k = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _k === void 0 ? void 0 : _k.loan) === null || _l === void 0 ? void 0 : _l.defaultPayments) === null || _m === void 0 ? void 0 : _m.defaultPaymentsDue) === null || _o === void 0 ? void 0 : _o.forEach(function (defpayment) {
          var _a;
          if (((_a = defpayment.paymentType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == "r" && (defpayment.defaultPaymentType == defaulPaymentType.PIT || defpayment.defaultPaymentType == defaulPaymentTypeStr.PIT)) {
            paymentDueDate = defpayment.paymentDueDate;
          }
        });
      }
      return paymentDueDate;
    };
    var getMaxPaymentEffectiveDate = function () {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j;
      var maxPaymentEffectiveDate = !((_a = layout.paymentModel) === null || _a === void 0 ? void 0 : _a.mustMakeDelinquentPayment) ? moment(layout.localTime).add(59, 'day') : moment(layout.localTime).endOf('month');
      if (((_d = (_c = (_b = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _b === void 0 ? void 0 : _b.loan) === null || _c === void 0 ? void 0 : _c.defaultPayments) === null || _d === void 0 ? void 0 : _d.route) == "Default" || ((_g = (_f = (_e = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _e === void 0 ? void 0 : _e.loan) === null || _f === void 0 ? void 0 : _f.defaultPayments) === null || _g === void 0 ? void 0 : _g.route) == "Delinquent") {
        maxPaymentEffectiveDate = moment((_j = (_h = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _h === void 0 ? void 0 : _h.loan) === null || _j === void 0 ? void 0 : _j.defaultPayments.maxPaymentEffectiveDate);
      }
      return maxPaymentEffectiveDate;
    };
    var onChange = function (value, property) {
      var _a;
      if (checkForAllNumbersCurrency(value)) {
        _this.setState({
          payment: __assign(__assign({}, _this.state.payment), (_a = {}, _a[property] = value, _a))
        }, function () {
          _this.setState({
            payment: __assign(__assign({}, _this.state.payment), {
              totalDraftAmount: _this.totalDraftAmountFun()
            })
          });
        });
      }
    };
    var onChangeFee = function (value, property) {
      var existingFees = 0;
      var allFes = __spreadArray([], paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.pendingPayments.filter(function (s) {
        var _a;
        return ((_a = s.feesDues) === null || _a === void 0 ? void 0 : _a.find(function (d) {
          return d.fieldName == property;
        })) && s.achConfigurationKey != payment.achConfigurationKey;
      }), true);
      if (allFes.length > 0) {
        allFes.forEach(function (e) {
          existingFees += isNaN(parseFloat(e.feesDues.find(function (d) {
            return d.fieldName == property;
          }).orignalFeeAmt)) ? 0 : parseFloat(e.feesDues.find(function (d) {
            return d.fieldName == property;
          }).orignalFeeAmt);
        });
      }
      var amount = edit ? isNaN(parseFloat(value)) ? 0 + existingFees : parseFloat(value) + existingFees : isNaN(parseFloat(value)) ? 0 : parseFloat(value);
      if (parseFloat(_this.getStateValueOriginal(property)) >= amount && checkForAllNumbersCurrency(value)) {
        var fees = _this.state.payment.feesDues;
        if (fees.find(function (s) {
          return s.fieldName == property;
        })) {
          fees.find(function (s) {
            return s.fieldName == property;
          }).feeAmtField = value;
        }
        _this.setState({
          payment: __assign(__assign({}, _this.state.payment), {
            feesDues: fees
          })
        }, function () {
          _this.setState({
            payment: __assign(__assign({}, _this.state.payment), {
              totalDraftAmount: _this.totalDraftAmountFun()
            })
          });
        });
      }
    };
    var aheadOneMonth = moment(nextPaymentDueDate).clone().add(1, "month");
    var disableDate = function (date) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
      if (date == "" || !date) {
        return true;
      }
      if (isOtp) {
        var blackDate = (_a = paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.blackoutDates) === null || _a === void 0 ? void 0 : _a.map(function (s) {
          return moment(s).format("MM/DD/YYYY");
        });
        if (edit && blackDate && paymentModel && paymentModel.blackoutDates && _this.state.payment && _this.state.payment.effectiveDate) {
          blackDate === null || blackDate === void 0 ? void 0 : blackDate.splice(paymentModel.blackoutDates.findIndex(function (s) {
            return moment(s).format("MM/DD/YYYY") == moment(_this.state.payment.effectiveDate).format("MM/DD/YYYY");
          }), 1);
        }
        if (((_b = _this.state.payment) === null || _b === void 0 ? void 0 : _b.paymentType) == 201297 && canMakePrincipleReduction && moment(date) > moment(layout.localTime).endOf('month')) {
          return true;
        }
        if (blackDate === null || blackDate === void 0 ? void 0 : blackDate.find(function (s) {
          return s == moment(date).format("MM/DD/YYYY");
        })) {
          return true;
        }
        var dd = moment(date, "MM/DD/YYYY", true);
        if (!dd.isValid() || moment(date).isBefore(moment(layout.localTime).add("days", -1))) {
          return true;
        }
        if (((_e = (_d = (_c = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _c === void 0 ? void 0 : _c.loan) === null || _d === void 0 ? void 0 : _d.defaultPayments) === null || _e === void 0 ? void 0 : _e.route) == "Default" || ((_h = (_g = (_f = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _f === void 0 ? void 0 : _f.loan) === null || _g === void 0 ? void 0 : _g.defaultPayments) === null || _h === void 0 ? void 0 : _h.route) == "Delinquent") {
          if (moment(date.date()).isAfter(moment((_k = (_j = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _j === void 0 ? void 0 : _j.loan) === null || _k === void 0 ? void 0 : _k.defaultPayments.maxPaymentEffectiveDate))) {
            return true;
          }
        } else if (moment(date).isSameOrAfter(moment(layout.localTime).add('days', 60))) {
          return true;
        }
      }
      return false;
    };
    var checkDate = function (amount) {
      var dtc = moment(layout.localTime);
      var retv = 4;
      for (var i = 1; i <= amount; i++) {
        var d = dtc.add('days', 1);
        if (d.day() == 0) {
          retv = 5;
        }
      }
      return retv;
    };
    var achStart = moment(originalNextPaymentDueDate).set('month', moment(layout.localTime).month()).set('year', moment(layout.localTime).year());
    var monthlyPaymentdisabled = paymentWindow || !(((_r = this.state.payment) === null || _r === void 0 ? void 0 : _r.delinquentPayments) ? ((_t = (_s = this.state.payment) === null || _s === void 0 ? void 0 : _s.delinquentPayments) === null || _t === void 0 ? void 0 : _t.length) > 0 ? (_v = (_u = this.state.payment) === null || _u === void 0 ? void 0 : _u.delinquentPayments) === null || _v === void 0 ? void 0 : _v.some(function (s) {
      return !s.paid;
    }) : true : true);
    var principalReductionedisabled = !canMakePrincipleReduction || parseInt(bankAccountType) == 201288;
    var additionalAmountDisabled = !canMakeAdditionalAmounts;
    var draftDate = [{
      key: -1,
      label: "".concat(achStart.clone().date()),
      value: achStart.clone().date(),
      date: achStart.clone().format("MM/DD/YYYY")
    }];
    var days = graceDays + 1;
    for (var i = 1; i < days; i++) {
      if (achStart.clone().add("day", i).isSameOrAfter(moment(layout.localTime).endOf('month'))) {
        break;
      }
      draftDate.push({
        key: i,
        label: "".concat(achStart.clone().add("day", i).date()),
        value: achStart.clone().add("day", i).date(),
        date: achStart.clone().add("day", i).format("MM/DD/YYYY")
      });
    }
    var stylesPaymentMethod = StyleSheet.create({
      container: {
        padding: 0,
        backgroundColor: "white",
        borderRadius: 7,
        shadowColor: "#000",
        shadowOffset: {
          width: 0,
          height: 2
        },
        shadowOpacity: 0.25,
        shadowRadius: 3.84,
        elevation: 5,
        marginHorizontal: 15,
        marginTop: 30,
        marginLeft: 10,
        marginRight: 10
      },
      editContainer: {
        padding: 0,
        backgroundColor: "white",
        borderRadius: 7,
        shadowColor: "#000",
        shadowOffset: {
          width: 0,
          height: 2
        },
        shadowOpacity: 0.25,
        shadowRadius: 3.84,
        elevation: 5,
        marginHorizontal: 15,
        marginTop: 30
      },
      paymentMethodRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        height: 62.8,
        alignItems: "center",
        paddingLeft: 17.5,
        paddingRight: 14.5
      },
      paymentMethodTitle: {
        fontFamily: "HalenoirCompactText-Medium",
        fontSize: 14,
        color: "#5C5C5C"
      },
      divider: {
        height: 1,
        width: "100%",
        backgroundColor: "#CCCCCC"
      },
      innerDivider: {
        height: 1,
        width: "90%",
        backgroundColor: "#CCCCCC",
        alignSelf: "center",
        marginBottom: 20
      },
      rightContent: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: 'flex-end',
        flex: 0.8
      },
      chevronRight: {
        marginLeft: 7.9,
        width: 10,
        height: 10,
        transform: [{
          rotate: '180deg'
        }]
      },
      inputContainer: {
        paddingTop: 19,
        marginHorizontal: 19
      },
      input: {
        height: 41,
        marginTop: 9.9
      },
      totalPaymentAmountContainer: {
        backgroundColor: "#F7F7F7",
        borderRadius: 5,
        height: 43,
        marginHorizontal: 18,
        marginTop: 19.1,
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        paddingLeft: 13.5,
        paddingRight: 14,
        marginBottom: 17.9
      },
      totalPaymentAmountTitle: {
        color: "#1B1B1B",
        fontFamily: "HalenoirCompactText-Medium",
        fontSize: 14
      },
      totalPaymentAmountValue: {
        color: "#117AAA",
        fontFamily: "HalenoirCompactText-Bold",
        fontWeight: "bold",
        fontSize: 14
      },
      paymentDateRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        height: 62.8,
        alignItems: "center",
        paddingLeft: 17.5,
        paddingRight: 14.5
      },
      paymentDateTitle: {
        fontFamily: "HalenoirCompactText-Medium",
        fontSize: 14,
        color: "#5C5C5C"
      },
      paymentBottomInfo: {
        fontFamily: "HalenoirCompactText-Medium",
        fontSize: 14,
        color: "#5C5C5C"
      },
      bottomInfoContainer: {
        marginTop: 15
      },
      bottomContent: {
        marginTop: 20,
        marginHorizontal: 20
      },
      paymentValue: {
        fontFamily: "Montserrat",
        fontWeight: "bold",
        fontSize: 32,
        color: "#117AAA",
        marginTop: 4.4,
        marginBottom: 10
      },
      autoPayDetailsRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        paddingLeft: 5,
        paddingRight: 5
      },
      autoPayDetailsDescriptionTitle: {
        fontFamily: "HalenoirCompactText-Medium",
        fontSize: 13,
        color: "#5C5C5C",
        textAlign: 'center'
      },
      autoPayDetailsPaymentsTitle: {
        fontFamily: "HalenoirCompactText-Bold",
        fontSize: 14,
        color: "#117AAA"
      },
      togglecontainer: {
        justifyContent: 'center',
        alignContent: 'center'
      },
      inner: {
        width: 13,
        height: 13,
        backgroundColor: 'white',
        borderRadius: 15
      },
      outer: {
        width: 28,
        height: 18,
        borderRadius: 18,
        alignItems: 'center',
        flexDirection: 'row',
        padding: 3
      }
    });
    var getSelectBankAccount = function () {
      return _this.state.payment.bankAccount;
    };
    var getBankAccountTypeSelectionOptions = function () {
      var _a, _b;
      return /*#__PURE__*/React.createElement(BankAccounts, __assign({
        trackerDispatcher: _this.props.trackerDispatcher,
        matches: matches,
        translations: translations,
        layout: layout,
        isOtp: isOtp,
        selectedView: _this.props.layout.paymentModel.selectedView,
        bankAccounts: (_b = (_a = _this.props.layout.paymentModel) === null || _a === void 0 ? void 0 : _a.bankAccounts) !== null && _b !== void 0 ? _b : [],
        navigation: _this.props.navigation,
        open: _this.state.selectedView === '',
        closeModal: function () {
          _this.props.dispatch({
            type: NACHA_BANKACCOUNT,
            paymentModel: __assign(__assign({}, _this.props.layout.paymentModel), {
              selectedView: 'PaymentMethodSelectBankAccount'
            })
          });
        },
        getSelectedBankAccount: getSelectBankAccount,
        updateSelectedView: function (view) {
          _this.props.dispatch({
            type: NACHA_BANKACCOUNT,
            paymentModel: __assign(__assign({}, _this.props.layout.paymentModel), {
              selectedView: "PaymentMethod".concat(view)
            })
          });
        },
        updateSelectedBankAccount: function (bankAccount) {
          var selectedBankAccount = _this.props.layout.paymentModel.bankAccounts.find(function (u) {
            return u.accountNumber == bankAccount.accountNumber && u.bankAccountType == bankAccount.bankAccountType && u.routingTransitNumber == bankAccount.routingTransitNumber && u.unmaskedAccountNumber == bankAccount.unmaskedAccountNumber;
          });
          var payments = _this.state.payment;
          payments.bankAccount = __assign({}, selectedBankAccount);
          _this.setState(function (prev) {
            return {
              isPaymentMethodUpdated: true,
              payment: __assign(__assign({}, prev.payment), {
                bankAccount: selectedBankAccount
              })
            };
          }, function () {
            _this.props.dispatch({
              type: NACHA_BANKACCOUNT,
              paymentModel: __assign(__assign({}, _this.props.layout.paymentModel), {
                selectedView: 'PaymentMethodOneTimePayment'
              })
            });
          });
        },
        deleteBank: function (account) {
          var index = _this.props.layout.paymentModel.bankAccounts.findIndex(function (u) {
            return u.accountNumber == account.accountNumber;
          });
          var paymentModel = __assign({}, _this.props.layout.paymentModel);
          paymentModel.bankAccounts.splice(index, 1);
          if (paymentModel.payment.bankAccount.unmaskedAccountNumber == account.unmaskedAccountNumber) {
            paymentModel.payment.bankAccount = null;
          }
          var statePayment = __assign({}, _this.state.payment);
          var bankAccount = statePayment.bankAccount.unmaskedAccountNumber == account.unmaskedAccountNumber ? undefined : statePayment.bankAccount;
          _this.setState(function (prev) {
            return {
              isPaymentMethodUpdated: true,
              payment: __assign(__assign({}, prev.payment), {
                bankAccount: bankAccount
              })
            };
          }, function () {
            _this.props.dispatch({
              type: NACHA_BANKACCOUNT,
              paymentModel: paymentModel
            });
          });
        },
        addBank: function (account) {
          var payment = _this.props.layout.paymentModel;
          payment.bankAccounts.push(__assign(__assign({}, account), {
            unmaskedAccountNumber: account.bankAccountNumber,
            accountFirstName: account.bankAccountFirstName,
            accountMiddleName: account.bankAccountMiddleName,
            accountLastName: account.bankAccountLastName,
            confirmAccountNumber: account.bankAccountNumber,
            newlyAdded: true
          }));
          payment.bankAccounts.reverse();
          _this.props.dispatch({
            type: NACHA_BANKACCOUNT,
            paymentModel: payment
          });
        }
      }, _this.props));
    };
    var getPaymentType = function () {
      var _a, _b, _c;
      return /*#__PURE__*/React.createElement(View, {
        style: {
          marginLeft: 15,
          marginRight: 15
        }
      }, /*#__PURE__*/React.createElement(PnmacTable, {
        style: {
          margin: 10,
          backgroundColor: "#FFF",
          borderRadius: 10,
          shadowColor: "rgba(0,0,0, .08)",
          shadowOffset: {
            height: 4,
            width: 2
          },
          shadowOpacity: 1,
          shadowRadius: 12
        }
      }, !isTrialPaymentVisible && isOtp && _this.state.payment.paymentType != 1000146 ? /*#__PURE__*/React.createElement(PnmacRowItem, {
        key: "payment-type-monthly",
        rowContainerStyles: {
          borderBottomWidth: 2,
          borderBottomColor: "#E9E9E9",
          paddingVertical: 11,
          backgroundColor: "#FFF"
        },
        renderChildren: function () {
          var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
          return /*#__PURE__*/React.createElement(View, {
            style: {
              height: 42,
              justifyContent: 'center'
            }
          }, /*#__PURE__*/React.createElement(TouchableOpacity, __assign({}, testID('updatePaymentTypeMonthly'), {
            disabled: paymentWindow || edit || !(((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.delinquentPayments) ? ((_c = (_b = _this.state.payment) === null || _b === void 0 ? void 0 : _b.delinquentPayments) === null || _c === void 0 ? void 0 : _c.length) > 0 ? (_e = (_d = _this.state.payment) === null || _d === void 0 ? void 0 : _d.delinquentPayments) === null || _e === void 0 ? void 0 : _e.some(function (s) {
              return !s.paid;
            }) : true : true),
            onPress: function () {
              var _a;
              _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/Payment Type-Monthly Payment|Mobile', -1, '', false);
              paymentType(201298);
              disableDebit(true);
              _this.setState({
                payment: __assign(__assign({}, _this.state.payment), {
                  paymentType: _this.monthlyPayment(),
                  effectiveDate: moment(payment === null || payment === void 0 ? void 0 : payment.originalEffectiveDate) || ((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.effectiveDate),
                  totalDraftAmount: _this.totalDraftAmountFun(),
                  additionalPrincipalAmount: "0.00",
                  additionalEscrowAmount: "0.00"
                })
              }, function () {
                _this.setState({
                  payment: __assign(__assign({}, _this.state.payment), {
                    totalDraftAmount: _this.totalDraftAmountFun()
                  })
                });
              });
              _this.props.dispatch({
                type: NACHA_BANKACCOUNT,
                paymentModel: __assign(__assign({}, _this.props.layout.paymentModel), {
                  selectedView: 'PaymentMethodOneTimePayment'
                })
              });
            },
            style: {
              marginLeft: 15
            }
          }), /*#__PURE__*/React.createElement(View, {
            style: {
              flexDirection: "row",
              alignItems: 'center'
            }
          }, _this.state.payment.paymentType == 201298 || ((_f = _this.state.payment) === null || _f === void 0 ? void 0 : _f.paymentType) == 201311 ? /*#__PURE__*/React.createElement(Image, {
            alt: "View details",
            source: require("./../../../assets/selected-green-tick-icon.jpg")
          }) : /*#__PURE__*/React.createElement(Image, {
            alt: "View details",
            source: require("./../../../assets/radio-icon-unselected.jpg")
          }), /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('monthlyPayment'), {
            style: {
              fontFamily: 'HalenoirCompactText-Medium',
              color: paymentWindow || edit || !(((_g = _this.state.payment) === null || _g === void 0 ? void 0 : _g.delinquentPayments) ? ((_j = (_h = _this.state.payment) === null || _h === void 0 ? void 0 : _h.delinquentPayments) === null || _j === void 0 ? void 0 : _j.length) > 0 ? (_l = (_k = _this.state.payment) === null || _k === void 0 ? void 0 : _k.delinquentPayments) === null || _l === void 0 ? void 0 : _l.some(function (s) {
                return !s.paid;
              }) : true : true) ? '#808080' : '#1B1B1B',
              padding: 5,
              fontSize: 14
            }
          }), translations.MonthlyPayment), /*#__PURE__*/React.createElement(View, {
            style: {
              marginLeft: 'auto',
              marginRight: 15
            }
          }, /*#__PURE__*/React.createElement(Image, {
            alt: "View details",
            source: require("./../../../assets/cheveron-black-right.jpg")
          })))));
        }
      }) : /*#__PURE__*/React.createElement(React.Fragment, null), !isTrialPaymentVisible && isOtp && _this.state.payment.paymentType != 1000146 ? /*#__PURE__*/React.createElement(PnmacRowItem, {
        key: "payment-type-principal",
        rowContainerStyles: {
          borderBottomWidth: 2,
          borderBottomColor: "#E9E9E9",
          paddingVertical: 11,
          backgroundColor: "#FFF"
        },
        renderChildren: function () {
          var _a;
          return /*#__PURE__*/React.createElement(View, {
            style: {
              height: 42,
              justifyContent: 'center'
            }
          }, /*#__PURE__*/React.createElement(TouchableOpacity, __assign({}, testID('updatePaymentMethodPrincipalReduction'), {
            disabled: !canMakePrincipleReduction || edit || parseInt(bankAccountType) == 201288,
            onPress: function () {
              var _a, _b, _c, _d;
              _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/Payment Type-Additional Principal|Mobile', -1, '', false);
              paymentType(201297);
              disableDebit();
              _this.setState({
                selectedView: 'PaymentMethodOneTimePayment',
                destinationView: 'PaymentMethodOneTimePayment',
                payment: __assign(__assign({}, _this.state.payment), {
                  paymentType: 201297,
                  bankAccountType: (_b = (_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.bankAccount) === null || _b === void 0 ? void 0 : _b.bankAccountType,
                  additionalPrincipalAmount: "0.00",
                  additionalEscrowAmount: "0.00",
                  bankAccount: __assign(__assign({}, _this.state.payment.bankAccount), {
                    bankAccountType: parseInt(bankAccountType) == 201288 ? 201287 : (_d = (_c = _this.state.payment) === null || _c === void 0 ? void 0 : _c.bankAccount) === null || _d === void 0 ? void 0 : _d.bankAccountType
                  })
                })
              }, function () {
                _this.setState({
                  payment: __assign(__assign({}, _this.state.payment), {
                    selectedView: 'PaymentMethodOneTimePayment',
                    destinationView: 'PaymentMethodOneTimePayment',
                    totalDraftAmount: _this.totalDraftAmountFun(),
                    effectiveDate: moment(payment.originalEffectiveDate)
                  })
                }, function () {
                  _this.props.dispatch({
                    type: NACHA_BANKACCOUNT,
                    paymentModel: __assign(__assign({}, _this.props.layout.paymentModel), {
                      selectedView: 'PaymentMethodOneTimePayment'
                    })
                  });
                });
              });
            },
            style: {
              marginLeft: 15
            }
          }), /*#__PURE__*/React.createElement(View, {
            style: {
              flexDirection: "row",
              alignItems: 'center'
            }
          }, ((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.paymentType) == 201297 ? /*#__PURE__*/React.createElement(Image, {
            alt: "View details",
            source: require("./../../../assets/selected-green-tick-icon.jpg")
          }) : /*#__PURE__*/React.createElement(Image, {
            alt: "View details",
            source: require("./../../../assets/radio-icon-unselected.jpg")
          }), /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('principalReductionOnly'), {
            style: {
              fontFamily: 'HalenoirCompactText-Medium',
              color: !canMakePrincipleReduction || edit || parseInt(bankAccountType) == 201288 ? '#808080' : '#1B1B1B',
              padding: 5,
              fontSize: 14
            }
          }), translations.PrincipalReductionOnly), /*#__PURE__*/React.createElement(View, {
            style: {
              marginLeft: 'auto',
              marginRight: 15
            }
          }, /*#__PURE__*/React.createElement(Image, {
            alt: "View details",
            source: require("./../../../assets/cheveron-black-right.jpg")
          })))));
        }
      }) : /*#__PURE__*/React.createElement(React.Fragment, null), !isTrialPaymentVisible && isOtp && _this.state.payment.paymentType != 1000146 && (layout.currentLoan.escrowFlag || _this.totalFees() > 0) ? /*#__PURE__*/React.createElement(PnmacRowItem, {
        key: "payment-type-additional",
        rowContainerStyles: {
          borderBottomWidth: 2,
          borderBottomColor: "#E9E9E9",
          paddingVertical: 11,
          backgroundColor: "#FFF"
        },
        renderChildren: function () {
          var _a;
          return /*#__PURE__*/React.createElement(View, {
            style: {
              height: 42,
              justifyContent: 'center'
            }
          }, /*#__PURE__*/React.createElement(TouchableOpacity, __assign({}, testID('updatePaymentMethodPrincipalReduction'), {
            disabled: !canMakeAdditionalAmounts || edit,
            onPress: function () {
              var _a;
              _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/Payment Type-Additional Amounts|Mobile', -1, '', false);
              paymentType(201299);
              disableDebit(true);
              _this.setState({
                payment: __assign(__assign({}, _this.state.payment), {
                  paymentType: 201299,
                  additionalPrincipalAmount: "0.00",
                  additionalEscrowAmount: "0.00",
                  effectiveDate: moment(payment === null || payment === void 0 ? void 0 : payment.originalEffectiveDate) || ((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.effectiveDate)
                })
              }, function () {
                _this.setState({
                  payment: __assign(__assign({}, _this.state.payment), {
                    totalDraftAmount: _this.totalDraftAmountFun()
                  })
                }, function () {
                  return _this.props.dispatch({
                    type: NACHA_BANKACCOUNT,
                    paymentModel: __assign(__assign({}, _this.props.layout.paymentModel), {
                      selectedView: 'PaymentMethodOneTimePayment'
                    })
                  });
                });
              });
            },
            style: {
              marginLeft: 15
            }
          }), /*#__PURE__*/React.createElement(View, {
            style: {
              flexDirection: "row",
              alignItems: 'center'
            }
          }, ((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.paymentType) == 201299 ? /*#__PURE__*/React.createElement(Image, {
            alt: "View details",
            source: require("./../../../assets/selected-green-tick-icon.jpg")
          }) : /*#__PURE__*/React.createElement(Image, {
            alt: "View details",
            source: require("./../../../assets/radio-icon-unselected.jpg")
          }), /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('principalReductionOnly'), {
            style: {
              fontSize: 14,
              fontFamily: 'HalenoirCompactText-Medium',
              color: !canMakeAdditionalAmounts || edit ? '#808080' : '#1B1B1B',
              padding: 5
            }
          }), translations.AdditionalAmountsOnly), /*#__PURE__*/React.createElement(View, {
            style: {
              marginLeft: 'auto',
              marginRight: 15
            }
          }, /*#__PURE__*/React.createElement(Image, {
            alt: "View details",
            source: require("./../../../assets/cheveron-black-right.jpg")
          })))));
        }
      }) : /*#__PURE__*/React.createElement(React.Fragment, null)), (_this.state.payment.paymentType == 201298 || ((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.paymentType) == 201311) && isOtp && (paymentWindow && !isTrialPaymentVisible ? /*#__PURE__*/React.createElement(BannerView, {
        style: {
          marginTop: 5,
          marginHorizontal: 10
        }
      }, /*#__PURE__*/React.createElement(BannerView.Text, null, (_b = translations.ScheduledMaximumMonthlyPayments) === null || _b === void 0 ? void 0 : _b.replace("{0}", "60"))) : ((_c = paymentStatus(status, "delinquent", [])) === null || _c === void 0 ? void 0 : _c.hasStatus) || !canMakePrincipleReduction || edit || parseInt(bankAccountType) == 201288 ? /*#__PURE__*/React.createElement(BannerView, {
        style: {
          marginTop: 5,
          marginHorizontal: 10
        }
      }, /*#__PURE__*/React.createElement(BannerView.Text, null, translations.UntilMonthlyPaymentsPaid)) : null));
    };
    var getSelectedPaymentType = function () {
      var _a;
      switch ((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.paymentType) {
        case 201298:
        case 201311:
          return translations.MonthlyPayment;
          break;
        case 201297:
          return translations.PrincipalReductionOnly;
          break;
        case 201299:
          return translations.AdditionalAmountsOnly;
          break;
        case 201296:
          return 'Modification Trial Payment ';
        default:
          return '';
      }
    };
    var isDeliquentPayment = function () {
      var _a;
      return (((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.paymentType) == 201311 || __spreadArray([], payment.delinquentPayments, true).length > 0) && (edit && !getActiveFeatures(layout.features, "BRMS_Delinquent", layout.whitelisted) ? layout.paymentModel.numberofPendingPayments > 1 : true);
    };
    var getRequiredDelinquentPayments = function () {
      return _this.state.payment.delinquentPayments;
    };
    var delinquentPayment = this.state.payment.delinquentPayments;
    var getDeliquentPayment = function () {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
      return /*#__PURE__*/React.createElement(React.Fragment, null, getRequiredDelinquentPayments().map(function (t, i) {
        var _a, _b, _c, _d, _e, _f, _g;
        return /*#__PURE__*/React.createElement(React.Fragment, null, t.mandatory == true && /*#__PURE__*/React.createElement(View, {
          style: {
            display: 'flex',
            direction: 'column',
            margin: 20,
            marginRight: 20,
            marginBottom: 5,
            marginTop: 10
          }
        }, /*#__PURE__*/React.createElement(View, {
          style: {
            display: "flex",
            flexDirection: "row",
            marginRight: 0
          }
        }, /*#__PURE__*/React.createElement(View, {
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement(PnmacText, {
          style: __assign(__assign({}, textStyle.defaultTextDescription), {
            fontSize: 14,
            fontFamily: 'HalenoirCompactText-Medium'
          }),
          idTag1: 'lblPaymentDueOn'
        }, 'Payment Due')), /*#__PURE__*/React.createElement(View, {
          style: {
            flex: 2,
            alignItems: Platform.OS === 'web' ? undefined : 'flex-end'
          }
        }, /*#__PURE__*/React.createElement(View, {
          style: {
            alignItems: 'flex-end'
          }
        }, /*#__PURE__*/React.createElement(PnmacText, {
          idTag1: 'lblNextPaymentDueDate',
          style: {
            fontSize: 14,
            fontFamily: 'HalenoirCompactText-Medium',
            color: '#1B1B1B'
          }
        }, moment(t.dueDate).format("MM/DD/YYYY"))))), /*#__PURE__*/React.createElement(View, {
          style: {
            display: "flex",
            flexDirection: "row",
            marginTop: 5
          }
        }, t.status == 'Pending' ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
          style: {
            backgroundColor: "#14882C",
            width: 65,
            height: 15,
            borderRadius: 9,
            alignItems: "center",
            justifyContent: "center"
          }
        }, /*#__PURE__*/React.createElement(PnmacText, {
          style: {
            color: "#FFFFFF",
            fontFamily: "Montserrat",
            fontSize: 11,
            fontWeight: "bold",
            paddingLeft: 6,
            paddingRight: 6,
            textTransform: "uppercase"
          }
        }, translations.PaymentStatusTypePending))) : /*#__PURE__*/React.createElement(View, null, layout.mobile ? /*#__PURE__*/React.createElement(PnmacText, {
          style: [{
            color: '#117AAA',
            fontSize: 12,
            fontFamily: 'HalenoirCompactText-Bold'
          }],
          idTag1: 'lblPaymentAmountDue'
        }, translations.RequiredAmountDue) : /*#__PURE__*/React.createElement(PnmacToolTip, {
          style: textStyle.defaultTextDescription,
          text: translations.PaymentAmountDue,
          title: translations.DefaultPaymentsPaymentAmountMessage
        })), /*#__PURE__*/React.createElement(View, {
          style: {
            marginLeft: 'auto',
            marginRight: 0
          }
        }, /*#__PURE__*/React.createElement(PnmacText, {
          style: [textStyle.formBodyTotal, {
            color: '#117AAA',
            fontSize: 12,
            fontFamily: 'HalenoirCompactText-Bold'
          }],
          idTag1: 'lblMonthlyPaymentAmount'
        }, currencyFormatter('en-US', 'currency', 'USD', t.paymentAmount))))), t.mandatory != true && /*#__PURE__*/React.createElement(View, {
          style: {
            display: 'flex',
            direction: 'column',
            margin: 20,
            marginRight: 20,
            marginBottom: 5
          }
        }, /*#__PURE__*/React.createElement(View, {
          style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center"
          }
        }, !t.paid && /*#__PURE__*/React.createElement(View, {
          style: {
            paddingRight: 8
          }
        }, /*#__PURE__*/React.createElement(PnmacCheckBox, {
          idTag1: 'chkDeliquentPayment',
          disabled: !((_b = (_a = getRequiredDelinquentPayments()) === null || _a === void 0 ? void 0 : _a[i - 1]) === null || _b === void 0 ? void 0 : _b.selected) && ((_d = (_c = getRequiredDelinquentPayments()) === null || _c === void 0 ? void 0 : _c[i - 1]) === null || _d === void 0 ? void 0 : _d.status) != "Pending" || ((_f = (_e = getRequiredDelinquentPayments()) === null || _e === void 0 ? void 0 : _e[i - 1]) === null || _f === void 0 ? void 0 : _f.status) == "Pending" && i + 1 == ((_g = getRequiredDelinquentPayments()) === null || _g === void 0 ? void 0 : _g.length) || edit,
          status: getRequiredDelinquentPayments()[i].selected ? 'checked' : 'unchecked',
          onPress: function () {
            if (getRequiredDelinquentPayments()[i].selected) {
              getRequiredDelinquentPayments()[i].selected = false;
              for (var j = i + 1; j < getRequiredDelinquentPayments().length; j++) {
                getRequiredDelinquentPayments()[j].selected = false;
              }
              _this.setState({
                deliquentPayment: false,
                payment: __assign(__assign({}, payment), {
                  t: t
                })
              });
            } else {
              getRequiredDelinquentPayments()[i].selected = true;
              _this.setState({
                deliquentPayment: true,
                payment: __assign(__assign({}, payment), {
                  t: t
                })
              });
            }
          }
        })), /*#__PURE__*/React.createElement(View, {
          style: {
            flex: 2
          }
        }, /*#__PURE__*/React.createElement(PnmacText, {
          style: __assign(__assign({}, textStyle.defaultTextDescription), {
            fontSize: 14,
            fontFamily: 'HalenoirCompactText-Medium'
          }),
          idTag1: 'lblPaymentDueOn'
        }, 'Payment Due')), /*#__PURE__*/React.createElement(View, {
          style: {
            flex: 2,
            alignItems: Platform.OS === 'web' ? undefined : 'flex-end'
          }
        }, /*#__PURE__*/React.createElement(View, {
          style: {
            alignItems: 'flex-end'
          }
        }, /*#__PURE__*/React.createElement(PnmacText, {
          idTag1: 'lblNextPaymentDueDate',
          style: {
            fontFamily: 'HalenoirCompactText-Medium',
            color: '#1B1B1B',
            fontSize: 14
          }
        }, moment(t.dueDate).format("MM/DD/YYYY"))))), /*#__PURE__*/React.createElement(View, {
          style: {
            display: "flex",
            flexDirection: "row",
            marginTop: 5
          }
        }, /*#__PURE__*/React.createElement(View, null, t.status == 'Pending' ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
          style: {
            backgroundColor: "#14882C",
            width: 65,
            height: 15,
            borderRadius: 9,
            alignItems: "center",
            justifyContent: "center"
          }
        }, /*#__PURE__*/React.createElement(PnmacText, {
          style: {
            color: "#FFFFFF",
            fontFamily: "Montserrat",
            fontSize: 11,
            fontWeight: "bold",
            paddingLeft: 6,
            paddingRight: 6,
            textTransform: "uppercase"
          }
        }, translations.PaymentStatusTypePending))) : layout.mobile ? /*#__PURE__*/React.createElement(PnmacText, {
          style: [{
            color: '#117AAA',
            fontSize: 12,
            fontFamily: 'HalenoirCompactText-Bold'
          }],
          idTag1: 'lblPaymentAmountDue'
        }, translations.AmountDue) : /*#__PURE__*/React.createElement(PnmacToolTip, {
          style: textStyle.defaultTextDescription,
          text: translations.PaymentAmountDue,
          title: translations.DefaultPaymentsPaymentAmountMessage
        })), /*#__PURE__*/React.createElement(View, {
          style: {
            marginLeft: 'auto',
            marginRight: 0
          }
        }, /*#__PURE__*/React.createElement(PnmacText, {
          style: [textStyle.formBodyTotal, {
            color: '#117AAA',
            fontSize: 12,
            fontFamily: 'HalenoirCompactText-Bold'
          }],
          idTag1: 'lblMonthlyPaymentAmount'
        }, currencyFormatter('en-US', 'currency', 'USD', t.paymentAmount))))), getRequiredDelinquentPayments().length - 1 != i && /*#__PURE__*/React.createElement(View, {
          style: __assign(__assign({}, stylesPaymentMethod.divider), {
            marginVertical: 10,
            width: '90%',
            marginHorizontal: 15,
            marginBottom: 0
          })
        }));
      }), (((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.paymentType) == 201298 || ((_b = _this.state.payment) === null || _b === void 0 ? void 0 : _b.paymentType) == 201309 || ((_c = _this.state.payment) === null || _c === void 0 ? void 0 : _c.paymentType) == 201311) && (!paymentWindow || !isOtp) && /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          width: "100%",
          paddingLeft: 20,
          marginTop: 10,
          paddingRight: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'lblPaymentAmount'
      }, translations.PaymentAmount), /*#__PURE__*/React.createElement(PnmacTextInput, {
        name: "monthlyPaymentAmount",
        returnKeyType: 'done',
        textAlign: 'left',
        nativeID: "txtPaymentAmt",
        mode: "outlined",
        disabled: true,
        disabledColored: true,
        style: {
          paddingTop: 10,
          height: 41
        },
        value: deliquentPayment || ((_d = _this.state.payment) === null || _d === void 0 ? void 0 : _d.paymentType) == 201311 ? "$".concat(_this.delinquentValue()) : "$".concat(_this.replaceDollarSign(((_e = layout.paymentModel) === null || _e === void 0 ? void 0 : _e.mustMakeDelinquentPayment) && layout.paymentModel.numberofPendingPayments == 0 ? _this.state.payment.delinquentPaymentAmount : _this.state.payment.monthlyPaymentAmount)),
        onChangeText: function (text) {
          return onChange(_this.replaceDollarSign(text), "monthlyPaymentAmount");
        }
      }))), _this.replaceDollarSign(_this.getStateValueOriginal("lateFeesDue")) > 0 && (((_f = _this.state.payment) === null || _f === void 0 ? void 0 : _f.paymentType) == 201298 || ((_g = _this.state.payment) === null || _g === void 0 ? void 0 : _g.paymentType) == 201299 || ((_h = _this.state.payment) === null || _h === void 0 ? void 0 : _h.paymentType) == 201311) && /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          width: "100%",
          paddingHorizontal: 15,
          marginTop: 15
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          justifyContent: 'flex-end'
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 1
        }
      }, !layout.mobile ? /*#__PURE__*/React.createElement("label", {
        for: "LateFeesDue"
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'LateFeesDue'
      }, translations.LateFeesDue)) : /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'LateFeesDue'
      }, translations.LateFeesDue)), /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 2,
          alignItems: 'flex-end',
          paddingRight: 5
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          color: '#117AAA',
          fontFamily: 'HalenoirCompactText-Bold'
        }
      }, "$".concat(_this.replaceDollarSign(_this.getStateValueOriginal("lateFeesDue", edit)))))), /*#__PURE__*/React.createElement(View, {
        style: Platform.OS === 'web' ? {
          flex: 2
        } : {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacTextInput, {
        mode: "outlined",
        textAlign: 'left',
        returnKeyType: 'done',
        accessibilityLabel: "Additional escrow",
        nativeID: "additionalEscrowAmount",
        style: {
          width: layout.mobile ? undefined : 200,
          paddingTop: 10,
          height: 41
        },
        disabled: parseFloat(_this.replaceDollarSign(_this.getStateValueOriginal("lateFeesDue"))) <= 0,
        keyboardType: layout.mobile ? "decimal-pad" : "default",
        payment: false,
        onBlur: function () {
          if (parseFloat(_this.replaceDollarSign(_this.getStateValue("lateFeesDue")) || 0) <= 0.01) {
            onChangeFee("0.00", "lateFeesDue");
          } else {
            if (!isNaN(parseFloat(_this.replaceDollarSign(_this.getStateValue("lateFeesDue"))))) {
              onChangeFee(parseFloat(_this.replaceDollarSign(_this.getStateValue("lateFeesDue"))).toFixed(2), "lateFeesDue");
            }
          }
        },
        onFocus: function () {
          if (parseFloat(_this.replaceDollarSign(_this.getStateValue("lateFeesDue")) || 0) <= 0.01) {
            onChangeFee("", "lateFeesDue");
          }
        },
        value: "$".concat(_this.replaceDollarSign(_this.getStateValue("lateFeesDue"))),
        onChangeText: function (text) {
          var _a;
          var amount = _this.replaceDollarSign(text);
          if (((_a = amount || "") === null || _a === void 0 ? void 0 : _a.countDecimals()) <= 2) {
            onChangeFee(amount, "lateFeesDue");
          }
        }
      })))), _this.replaceDollarSign(_this.getStateValueOriginal("nsfFeesDue")) > 0 && (((_j = _this.state.payment) === null || _j === void 0 ? void 0 : _j.paymentType) == 201298 || ((_k = _this.state.payment) === null || _k === void 0 ? void 0 : _k.paymentType) == 201299 || ((_l = _this.state.payment) === null || _l === void 0 ? void 0 : _l.paymentType) == 201311) && /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          width: "100%",
          paddingHorizontal: 15,
          paddingTop: 15
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          justifyContent: 'flex-end'
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 1
        }
      }, !layout.mobile ? /*#__PURE__*/React.createElement("label", {
        for: "lblNSFFeesDue"
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'LateFeesDue'
      }, translations.LateFeesDue)) : /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'LateFeesDue'
      }, translations.NSFFeesDue)), /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 2,
          alignItems: 'flex-end',
          paddingRight: 5
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          color: '#117AAA',
          fontFamily: 'HalenoirCompactText-Bold'
        }
      }, "$".concat(parseFloat(_this.replaceDollarSign(_this.getStateValueOriginal("nsfFeesDue"))).toFixed(2))))), /*#__PURE__*/React.createElement(View, {
        style: Platform.OS === 'web' ? {
          flex: 2
        } : {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacTextInput, {
        mode: "outlined",
        textAlign: 'left',
        returnKeyType: 'done',
        accessibilityLabel: "lblNSFFeesDue",
        nativeID: "lblNSFFeesDue",
        style: {
          width: layout.mobile ? undefined : 200,
          paddingTop: 10,
          height: 41
        },
        keyboardType: layout.mobile ? "decimal-pad" : "default",
        payment: false,
        onBlur: function () {
          if (parseFloat(_this.replaceDollarSign(_this.getStateValue("nsfFeesDue")) || 0) <= 0.01) {
            onChangeFee("0.00", "nsfFeesDue");
          } else {
            if (!isNaN(parseFloat(_this.replaceDollarSign(_this.getStateValue("nsfFeesDue"))))) {
              onChangeFee(parseFloat(_this.replaceDollarSign(_this.getStateValue("nsfFeesDue"))).toFixed(2), "nsfFeesDue");
            }
          }
        },
        onFocus: function () {
          if (parseFloat(_this.replaceDollarSign(_this.getStateValue("nsfFeesDue")) || 0) <= 0.01) {
            onChangeFee("", "nsfFeesDue");
          }
        },
        disabled: parseFloat(_this.replaceDollarSign(_this.getStateValueOriginal("nsfFeesDue"))) <= 0,
        value: "$".concat(_this.replaceDollarSign(_this.getStateValue("nsfFeesDue"))),
        onChangeText: function (text) {
          var _a;
          var amount = _this.replaceDollarSign(text);
          if (((_a = amount || "") === null || _a === void 0 ? void 0 : _a.countDecimals()) <= 2) {
            onChangeFee(amount, "nsfFeesDue");
          }
        }
      })))), _this.replaceDollarSign(_this.getStateValueOriginal("otherFeesDue")) > 0 && (((_m = _this.state.payment) === null || _m === void 0 ? void 0 : _m.paymentType) == 201298 || ((_o = _this.state.payment) === null || _o === void 0 ? void 0 : _o.paymentType) == 201299 || ((_p = _this.state.payment) === null || _p === void 0 ? void 0 : _p.paymentType) == 201311) && /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          width: "100%",
          paddingHorizontal: 15,
          paddingTop: 15
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          justifyContent: 'flex-end'
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 1
        }
      }, !layout.mobile ? /*#__PURE__*/React.createElement("label", {
        for: "lblOtherFeesDue"
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'lblOtherFeesDue'
      }, translations.OtherFeesDue)) : /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'lblOtherFeesDue'
      }, translations.OtherFeesDue)), /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 2,
          alignItems: 'flex-end',
          paddingRight: 5
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          color: '#117AAA',
          fontFamily: 'HalenoirCompactText-Bold'
        }
      }, "$".concat(parseFloat(_this.replaceDollarSign(_this.getStateValueOriginal("otherFeesDue"))).toFixed(2))))), /*#__PURE__*/React.createElement(View, {
        style: Platform.OS === 'web' ? {
          flex: 2
        } : {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacTextInput, {
        mode: "outlined",
        textAlign: 'left',
        returnKeyType: 'done',
        accessibilityLabel: "otherFeesDue",
        nativeID: "otherFeesDue",
        style: {
          width: layout.mobile ? undefined : 200,
          paddingTop: 10,
          height: 41
        },
        keyboardType: layout.mobile ? "decimal-pad" : "default",
        payment: false,
        onBlur: function () {
          if (parseFloat(_this.replaceDollarSign(_this.getStateValue("otherFeesDue")) || 0) <= 0.01) {
            onChangeFee("0.00", "otherFeesDue");
          } else {
            if (!isNaN(parseFloat(_this.replaceDollarSign(_this.getStateValue("otherFeesDue"))))) {
              onChangeFee(parseFloat(_this.replaceDollarSign(_this.getStateValue("otherFeesDue"))).toFixed(2), "otherFeesDue");
            }
          }
        },
        onFocus: function () {
          if (parseFloat(_this.replaceDollarSign(_this.getStateValue("otherFeesDue")) || 0) <= 0.01) {
            onChangeFee("", "otherFeesDue");
          }
        },
        disabled: parseFloat(_this.replaceDollarSign(_this.getStateValueOriginal("otherFeesDue"))) <= 0,
        name: "otherFeesDue",
        value: "$".concat(_this.replaceDollarSign(_this.getStateValue("otherFeesDue"))),
        onChangeText: function (text) {
          var _a;
          var amount = _this.replaceDollarSign(text);
          if (((_a = amount || "") === null || _a === void 0 ? void 0 : _a.countDecimals()) <= 2) {
            onChangeFee(amount, "otherFeesDue");
          }
        }
      })))), ((_q = layout.currentLoan) === null || _q === void 0 ? void 0 : _q.escrowFlag) && (((_r = _this.state.payment) === null || _r === void 0 ? void 0 : _r.paymentType) == 201298 || ((_s = _this.state.payment) === null || _s === void 0 ? void 0 : _s.paymentType) == 201299 || ((_t = _this.state.payment) === null || _t === void 0 ? void 0 : _t.paymentType) == 201311) && /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          width: "100%",
          paddingVertical: 20,
          paddingHorizontal: 15
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 1
        }
      }, !layout.mobile ? /*#__PURE__*/React.createElement("label", {
        for: "additionalEscrowAmount"
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'additionalEscrowAmount'
      }, translations.AdditionalPrincipal)) : /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'additionalEscrowAmount'
      }, translations.AdditionalEscrow)), /*#__PURE__*/React.createElement(View, {
        style: Platform.OS === 'web' ? {
          flex: 2
        } : {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacTextInput, {
        mode: "outlined",
        textAlign: 'left',
        returnKeyType: 'done',
        accessibilityLabel: "Additional escrow",
        nativeID: "additionalEscrowAmount",
        style: {
          width: layout.mobile ? undefined : 200,
          paddingTop: 10,
          height: 41
        },
        keyboardType: layout.mobile ? "decimal-pad" : "default",
        payment: false,
        onBlur: function () {
          var _a, _b, _c;
          if (parseFloat(_this.replaceDollarSign((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.additionalEscrowAmount) || 0) <= 0) {
            onChange("0.00", "additionalEscrowAmount");
          } else {
            if (!isNaN(parseFloat(_this.replaceDollarSign((_b = _this.state.payment) === null || _b === void 0 ? void 0 : _b.additionalEscrowAmount)))) {
              onChange(parseFloat(_this.replaceDollarSign((_c = _this.state.payment) === null || _c === void 0 ? void 0 : _c.additionalEscrowAmount)).toFixed(2), "additionalEscrowAmount");
            }
          }
        },
        onFocus: function () {
          var _a;
          if (parseFloat(_this.replaceDollarSign((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.additionalEscrowAmount) || 0) <= 0) {
            onChange("", "additionalEscrowAmount");
          }
        },
        value: "$".concat((_u = _this.state.payment) === null || _u === void 0 ? void 0 : _u.additionalEscrowAmount),
        onChangeText: function (text) {
          var _a;
          var amount = _this.replaceDollarSign(text);
          if (((_a = amount || "") === null || _a === void 0 ? void 0 : _a.countDecimals()) <= 2) {
            if (parseFloat(amount) <= 0.02) {
              onChange('0.00', "additionalEscrowAmount");
            } else {
              onChange(amount, "additionalEscrowAmount");
            }
          }
        }
      })))), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
        style: {
          padding: 10,
          marginVertical: 5,
          marginHorizontal: 10,
          color: '#5C5C5C',
          borderRadius: 5
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          color: '#5C5C5C',
          fontFamily: "Halenoir Compact Medium",
          fontSize: 12
        }
      }, translations.TotalPaymentMessage)), /*#__PURE__*/React.createElement(View, {
        style: {
          backgroundColor: '#FFFBE6',
          borderWidth: 2,
          borderStyle: 'solid',
          borderColor: '#F9EB9C',
          padding: 10,
          marginHorizontal: 15,
          marginVertical: 10,
          color: '#5C5C5C',
          borderRadius: 5
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          color: '#5C5C5C',
          fontFamily: "Halenoir Compact Medium",
          fontSize: 12
        }
      }, translations.CannotMakePaymentMessage)), /*#__PURE__*/React.createElement(View, {
        style: {
          backgroundColor: '#F0F9FC',
          borderWidth: 2,
          borderColor: '#CBEAF5',
          padding: 10,
          marginHorizontal: 15,
          color: '#5C5C5C',
          borderRadius: 5
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          color: '#5C5C5C',
          fontFamily: "Halenoir Compact Medium",
          fontSize: 12
        }
      }, translations.AdditionalFeesWarningMessage))), /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          paddingLeft: 20,
          paddingRight: 20,
          marginBottom: 20,
          marginTop: 20,
          backgroundColor: '#F7F7F7',
          borderColor: '#CBEAF5',
          marginHorizontal: 15,
          borderRadius: 5,
          height: 49
        }
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('TotalPaymentAmount'), {
        style: stylesPaymentMethod.totalPaymentAmountTitle
      }), translations.TotalPaymentAmount), /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('TotalPaymentAmountValue'), {
        style: __assign(__assign({}, stylesPaymentMethod.totalPaymentAmountValue), {
          maxWidth: width * 0.3
        })
      }), currencyFormatter('en-US', 'currency', 'USD', _this.totalDraftAmountFun()))));
    };
    var getCalendarMessage = function (type) {
      var messages = [{
        type: "201296",
        displayType: 'information',
        message: "The date up which you would like the payment to be applied. This date may differ from the date in which the actual funds from your account will be drawn, usually as a result of differences in active banking days and processing time. "
      }, {
        type: "201296",
        displayType: 'warning',
        message: "You have selected a date past your grace period 11/16/2023 and may incur an additional late fee of $29.33"
      }, {
        type: "201296",
        displayType: 'information',
        message: "Monthly Payments scheduled more than 30 days pas your due date will likely result in adverse credit reporting."
      }, {
        type: "default",
        displayType: 'information',
        message: "".concat(translations === null || translations === void 0 ? void 0 : translations.CanCancelPayment, "<br /><br />").concat(translations === null || translations === void 0 ? void 0 : translations.NachaBankAccountBusinessValidationMessage1, "<br /><br />").concat(translations === null || translations === void 0 ? void 0 : translations.NachaBankAccountBusinessValidationMessage2)
      }];
      return type == 201296 ? messages.filter(function (t) {
        return t.type == type;
      }).map(function (t) {
        if (t.displayType == 'information') {
          return /*#__PURE__*/React.createElement(View, {
            style: {
              backgroundColor: '#F0F9FC',
              borderWidth: 2,
              borderStyle: 'solid',
              borderColor: '#CBEAF5',
              padding: 10,
              marginVertical: 10,
              color: '#5C5C5C'
            }
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: {
              color: '#5C5C5C',
              fontFamily: "Halenoir Compact Medium",
              fontSize: 13
            }
          }, t.message));
        } else {
          return /*#__PURE__*/React.createElement(View, {
            style: {
              backgroundColor: '#FFFBE6',
              borderWidth: 2,
              borderColor: '#F9EB9C',
              padding: 10,
              marginVertical: 10,
              color: '#5C5C5C'
            }
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: {
              color: '#5C5C5C',
              fontFamily: "Halenoir Compact Medium",
              fontSize: 13
            }
          }, t.message));
        }
      }) : messages.filter(function (t) {
        return t.type == 'default';
      }).map(function (t) {
        return /*#__PURE__*/React.createElement(View, {
          style: {
            backgroundColor: '#F0F9FC',
            borderWidth: 2,
            borderStyle: 'solid',
            borderColor: '#CBEAF5',
            padding: 10,
            marginVertical: 10,
            color: '#5C5C5C'
          }
        }, /*#__PURE__*/React.createElement(HtmlToNativeNative, {
          value: t.message
        }));
      });
    };
    var marked = function () {
      var _a;
      return _a = {}, _a[moment(_this.state.currentSelectedDate).format('YYYY-MM-DD')] = {
        selected: true
      }, _a;
    };
    var getCalendar = function () {
      return /*#__PURE__*/React.createElement(View, {
        style: {
          margin: 10
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          marginBottom: 5
        }
      }, /*#__PURE__*/React.createElement(PnmacPaper, {
        disabled: true,
        style: stylesPaymentMethod.container
      }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          color: '#1B1B1B',
          fontSize: 14,
          margin: 15
        }
      }, 'Select an Effective Date')), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(OTPDatePicker, {
        getMaxPaymentEffectiveDate: getMaxPaymentEffectiveDate(),
        currentSelectedDate: _this.state.currentSelectedDate,
        updateCurrentSelectedDate: function (data) {
          return _this.setState(__assign(__assign({}, _this.state), {
            currentSelectedDate: data,
            isCurrentSelectedDateUpdated: true
          }));
        },
        disableDate: function (dt) {
          return disableDate(dt);
        }
      })))), /*#__PURE__*/React.createElement(View, {
        style: {
          marginHorizontal: 10,
          marginVertical: 5
        }
      }, getCalendarMessage(_this.state.paymentType)), /*#__PURE__*/React.createElement(View, {
        style: {
          marginVertical: 5,
          marginHorizontal: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        nativeID: "btnContinueButton",
        style: {
          height: 47.4,
          justifyContent: 'center',
          textAlign: 'center'
        },
        loading: _this.state.paymentSubmitted,
        disabled: moment(_this.state.currentSelectedDate) == moment(_this.state.payment.effectiveDate).format('YYYY-MM-DD'),
        mode: "contained",
        testID: "ContinueButtonText",
        onPress: function () {
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/Payment Date-Save date|Mobile', -1, "", false);
          _this.setState(__assign(__assign({}, _this.state), {
            isCurrentSelectedDateUpdated: false,
            payment: __assign(__assign({}, _this.state.payment), {
              effectiveDate: moment(_this.state.currentSelectedDate)
            })
          }), function () {
            _this.props.dispatch({
              type: NACHA_BANKACCOUNT,
              paymentModel: __assign(__assign({}, _this.props.layout.paymentModel), {
                selectedView: 'PaymentMethodOneTimePayment'
              })
            });
          });
        }
      }, 'Save Date')));
    };
    var getNonDeliquentPaymentComponent = function () {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17;
      return /*#__PURE__*/React.createElement(React.Fragment, null, !edit && (_this.state.payment.paymentType == 201298 || _this.state.payment.paymentType == 201296) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          direction: 'column',
          marginHorizontal: 20,
          marginRight: 20,
          marginTop: 15
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: __assign(__assign({}, textStyle.defaultTextDescription), {
          fontSize: 14,
          fontFamily: 'HalenoirCompactText-Medium'
        }),
        idTag1: 'lblPaymentDueOn'
      }, 'Payment Due')), /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 2,
          alignItems: Platform.OS === 'web' ? undefined : 'flex-end'
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          alignItems: 'flex-end'
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        idTag1: 'lblNextPaymentDueDate',
        style: {
          fontFamily: 'HalenoirCompactText-Medium',
          color: '#1B1B1B',
          fontSize: 14
        }
      }, moment(getMinimumPaymentDueDate()).format("MM/DD/YYYY"))))), /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "row",
          marginTop: 5
        }
      }, /*#__PURE__*/React.createElement(View, null, layout.mobile ? /*#__PURE__*/React.createElement(PnmacText, {
        style: [{
          color: '#117AAA',
          fontSize: 12,
          fontFamily: 'HalenoirCompactText-Bold'
        }],
        idTag1: 'lblPaymentAmountDue'
      }, translations.AmountDue) : /*#__PURE__*/React.createElement(PnmacToolTip, {
        style: textStyle.defaultTextDescription,
        text: translations.PaymentAmountDue,
        title: translations.DefaultPaymentsPaymentAmountMessage
      })), /*#__PURE__*/React.createElement(View, {
        style: {
          marginLeft: 'auto',
          marginRight: 0
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: [textStyle.formBodyTotal, {
          color: '#117AAA',
          fontSize: 12,
          fontFamily: 'HalenoirCompactText-Bold'
        }],
        idTag1: 'lblMonthlyPaymentAmount'
      }, currencyFormatter('en-US', 'currency', 'USD', getMinimumPaymentDue()))))), !edit && isOtp && ((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.paymentType) == 201298 && layout.isEscrowAnalysisEnabled && ((_b = _this.state.payment) === null || _b === void 0 ? void 0 : _b.changeinMonthlyPaymentAmount) != null && ((_c = _this.state.payment) === null || _c === void 0 ? void 0 : _c.changeinMonthlyPaymentAmount) ? /*#__PURE__*/React.createElement(BannerView, {
        type: 'warning',
        style: {
          marginTop: 15,
          marginHorizontal: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, _this.props, {
        size: 14,
        value: translations.PaymentEescrowlink,
        navigation: {
          navigate: function () {
            var label = "OTP/Escrow Payment Change|Mobile";
            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, label, -1, "", false);
            PnmacNavigation(__assign({
              action: {
                pathname: "/Loan/EscrowAnalysisPaymentChange"
              }
            }, _this.props));
          }
        },
        onClick: function (e) {
          var target = e.target.toString();
          if (target != null && target.indexOf('/Loan/EscrowAnalysisPaymentChange') > -1) {
            var label = "OTP/Escrow Payment Change|WEB";
            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, label, 0);
          }
        }
      }))) : null, _this.state.payment.paymentType == 201296 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          width: "100%",
          paddingLeft: 20,
          marginBottom: 20,
          paddingRight: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'lblPaymentAmount'
      }, translations.PaymentAmount), /*#__PURE__*/React.createElement(PnmacTextInput, {
        name: "monthlyPaymentAmount",
        textAlign: 'left',
        returnKeyType: 'done',
        nativeID: "txtPaymentAmt",
        mode: "outlined",
        disabled: true,
        disabledColored: true,
        style: {
          paddingTop: 10,
          height: 41
        },
        value: deliquentPayment || ((_d = _this.state.payment) === null || _d === void 0 ? void 0 : _d.paymentType) == 201311 ? "$".concat(_this.delinquentValue()) : "$".concat(_this.replaceDollarSign(((_e = layout.paymentModel) === null || _e === void 0 ? void 0 : _e.mustMakeDelinquentPayment) && layout.paymentModel.numberofPendingPayments == 0 ? _this.state.payment.delinquentPaymentAmount : _this.state.payment.monthlyPaymentAmount)),
        onChangeText: function (text) {
          return onChange(_this.replaceDollarSign(text), "monthlyPaymentAmount");
        }
      }))))), (((_f = _this.state.payment) === null || _f === void 0 ? void 0 : _f.paymentType) == 201298 || ((_g = _this.state.payment) === null || _g === void 0 ? void 0 : _g.paymentType) == 201309 || ((_h = _this.state.payment) === null || _h === void 0 ? void 0 : _h.paymentType) == 201311) && (!paymentWindow || !isOtp) ? /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          width: "100%",
          paddingHorizontal: 20,
          paddingVertical: 10
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 1
        }
      }, !layout.mobile ? /*#__PURE__*/React.createElement("label", {
        for: "txtPaymentAmt"
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'lblPaymentAmount'
      }, translations.PaymentAmount)) : /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'lblPaymentAmount'
      }, translations.PaymentAmount)), /*#__PURE__*/React.createElement(View, {
        style: Platform.OS === 'web' ? {
          flex: 2
        } : {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacTextInput, {
        name: "monthlyPaymentAmount",
        nativeID: "txtPaymentAmt",
        returnKeyType: 'done',
        textAlign: 'left',
        mode: "outlined",
        disabled: true,
        disabledColored: true,
        style: {
          cursor: "not-allowed",
          width: layout.mobile ? undefined : 200,
          paddingTop: 10,
          height: 41
        },
        value: deliquentPayment || ((_j = _this.state.payment) === null || _j === void 0 ? void 0 : _j.paymentType) == 201311 ? "$".concat(_this.delinquentValue()) : "$".concat(_this.replaceDollarSign(((_k = layout.paymentModel) === null || _k === void 0 ? void 0 : _k.mustMakeDelinquentPayment) && layout.paymentModel.numberofPendingPayments == 0 ? _this.state.payment.delinquentPaymentAmount : _this.state.payment.monthlyPaymentAmount)),
        onChangeText: function (text) {
          return onChange(_this.replaceDollarSign(text), "monthlyPaymentAmount");
        }
      }))) : null, (((_l = _this.state.payment) === null || _l === void 0 ? void 0 : _l.paymentType) == 201309 || ((_m = _this.state.payment) === null || _m === void 0 ? void 0 : _m.paymentType) == 201311) && (!paymentWindow || !isOtp) ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          width: "100%",
          paddingLeft: 20,
          marginBottom: 20,
          marginTop: 20,
          paddingRight: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'lblPaymentAmount'
      }, translations.PaymentAmount), /*#__PURE__*/React.createElement(PnmacTextInput, {
        name: "monthlyPaymentAmount",
        textAlign: 'left',
        returnKeyType: 'done',
        nativeID: "txtPaymentAmt",
        mode: "outlined",
        disabled: true,
        disabledColored: true,
        style: {
          paddingTop: 10,
          height: 41
        },
        value: deliquentPayment || ((_o = _this.state.payment) === null || _o === void 0 ? void 0 : _o.paymentType) == 201311 ? "$".concat(_this.delinquentValue()) : "$".concat(_this.replaceDollarSign(((_p = layout.paymentModel) === null || _p === void 0 ? void 0 : _p.mustMakeDelinquentPayment) && layout.paymentModel.numberofPendingPayments == 0 ? _this.state.payment.delinquentPaymentAmount : _this.state.payment.monthlyPaymentAmount)),
        onChangeText: function (text) {
          return onChange(_this.replaceDollarSign(text), "monthlyPaymentAmount");
        }
      }))) : null, _this.replaceDollarSign(_this.getStateValueOriginal("lateFeesDue")) > 0 && (((_q = _this.state.payment) === null || _q === void 0 ? void 0 : _q.paymentType) == 201298 || ((_r = _this.state.payment) === null || _r === void 0 ? void 0 : _r.paymentType) == 201299 || ((_s = _this.state.payment) === null || _s === void 0 ? void 0 : _s.paymentType) == 201311) && /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          width: "100%",
          paddingHorizontal: 20
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          justifyContent: 'flex-end'
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 1
        }
      }, !layout.mobile ? /*#__PURE__*/React.createElement("label", {
        for: "LateFeesDue"
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'LateFeesDue'
      }, translations.LateFeesDue)) : /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'LateFeesDue'
      }, translations.LateFeesDue)), /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 2,
          alignItems: 'flex-end',
          paddingRight: 5
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          color: '#117AAA',
          fontFamily: 'HalenoirCompactText-Bold'
        }
      }, "$".concat(_this.replaceDollarSign(_this.getStateValueOriginal("lateFeesDue", edit)))))), /*#__PURE__*/React.createElement(View, {
        style: Platform.OS === 'web' ? {
          flex: 2
        } : {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacTextInput, {
        mode: "outlined",
        textAlign: 'left',
        accessibilityLabel: "Additional escrow",
        returnKeyType: 'done',
        nativeID: "additionalEscrowAmount",
        style: {
          width: layout.mobile ? undefined : 200,
          paddingTop: 10,
          height: 41
        },
        disabled: parseFloat(_this.replaceDollarSign(_this.getStateValueOriginal("lateFeesDue"))) <= 0,
        keyboardType: layout.mobile ? "decimal-pad" : "default",
        payment: false,
        onBlur: function () {
          if (parseFloat(_this.replaceDollarSign(_this.getStateValue("lateFeesDue")) || 0) <= 0.01) {
            onChangeFee("0.00", "lateFeesDue");
          } else {
            if (!isNaN(parseFloat(_this.replaceDollarSign(_this.getStateValue("lateFeesDue"))))) {
              onChangeFee(parseFloat(_this.replaceDollarSign(_this.getStateValue("lateFeesDue"))).toFixed(2), "lateFeesDue");
            }
          }
        },
        onFocus: function () {
          if (parseFloat(_this.replaceDollarSign(_this.getStateValue("lateFeesDue")) || 0) <= 0.01) {
            onChangeFee("", "lateFeesDue");
          }
        },
        value: "$".concat(_this.replaceDollarSign(_this.getStateValue("lateFeesDue"))),
        onChangeText: function (text) {
          var _a;
          var amount = _this.replaceDollarSign(text);
          if (((_a = amount || "") === null || _a === void 0 ? void 0 : _a.countDecimals()) <= 2) {
            onChangeFee(amount, "lateFeesDue");
          }
        }
      })))), _this.replaceDollarSign(_this.getStateValueOriginal("nsfFeesDue")) > 0 && (((_t = _this.state.payment) === null || _t === void 0 ? void 0 : _t.paymentType) == 201298 || ((_u = _this.state.payment) === null || _u === void 0 ? void 0 : _u.paymentType) == 201299 || ((_v = _this.state.payment) === null || _v === void 0 ? void 0 : _v.paymentType) == 201311) && /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          width: "100%",
          paddingHorizontal: 20,
          paddingTop: 15
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          justifyContent: 'flex-end'
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 1
        }
      }, !layout.mobile ? /*#__PURE__*/React.createElement("label", {
        for: "lblNSFFeesDue"
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'LateFeesDue'
      }, translations.LateFeesDue)) : /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'LateFeesDue'
      }, translations.NSFFeesDue)), /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 2,
          alignItems: 'flex-end',
          paddingRight: 5
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          color: '#117AAA',
          fontFamily: 'HalenoirCompactText-Bold'
        }
      }, "$".concat(parseFloat(_this.replaceDollarSign(_this.getStateValueOriginal("nsfFeesDue"))).toFixed(2))))), /*#__PURE__*/React.createElement(View, {
        style: Platform.OS === 'web' ? {
          flex: 2
        } : {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacTextInput, {
        mode: "outlined",
        textAlign: 'left',
        returnKeyType: 'done',
        accessibilityLabel: "lblNSFFeesDue",
        nativeID: "lblNSFFeesDue",
        style: {
          width: layout.mobile ? undefined : 200,
          paddingTop: 10,
          height: 41
        },
        keyboardType: layout.mobile ? "decimal-pad" : "default",
        payment: false,
        onBlur: function () {
          if (parseFloat(_this.replaceDollarSign(_this.getStateValue("nsfFeesDue")) || 0) <= 0.01) {
            onChangeFee("0.00", "nsfFeesDue");
          } else {
            if (!isNaN(parseFloat(_this.replaceDollarSign(_this.getStateValue("nsfFeesDue"))))) {
              onChangeFee(parseFloat(_this.replaceDollarSign(_this.getStateValue("nsfFeesDue"))).toFixed(2), "nsfFeesDue");
            }
          }
        },
        onFocus: function () {
          if (parseFloat(_this.replaceDollarSign(_this.getStateValue("nsfFeesDue")) || 0) <= 0.01) {
            onChangeFee("", "nsfFeesDue");
          }
        },
        disabled: parseFloat(_this.replaceDollarSign(_this.getStateValueOriginal("nsfFeesDue"))) <= 0,
        value: "$".concat(_this.replaceDollarSign(_this.getStateValue("nsfFeesDue"))),
        onChangeText: function (text) {
          var _a;
          var amount = _this.replaceDollarSign(text);
          if (((_a = amount || "") === null || _a === void 0 ? void 0 : _a.countDecimals()) <= 2) {
            onChangeFee(amount, "nsfFeesDue");
          }
        }
      })))), _this.replaceDollarSign(_this.getStateValueOriginal("otherFeesDue")) > 0 && (((_w = _this.state.payment) === null || _w === void 0 ? void 0 : _w.paymentType) == 201298 || ((_x = _this.state.payment) === null || _x === void 0 ? void 0 : _x.paymentType) == 201299 || ((_y = _this.state.payment) === null || _y === void 0 ? void 0 : _y.paymentType) == 201311) && /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          width: "100%",
          paddingHorizontal: 20,
          paddingTop: 15
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          justifyContent: 'flex-end'
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 1
        }
      }, !layout.mobile ? /*#__PURE__*/React.createElement("label", {
        for: "lblOtherFeesDue"
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'lblOtherFeesDue'
      }, translations.OtherFeesDue)) : /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'lblOtherFeesDue'
      }, translations.OtherFeesDue)), /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 2,
          alignItems: 'flex-end',
          paddingRight: 5
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          color: '#117AAA',
          fontFamily: 'HalenoirCompactText-Bold'
        }
      }, "$".concat(parseFloat(_this.replaceDollarSign(_this.getStateValueOriginal("otherFeesDue"))).toFixed(2))))), /*#__PURE__*/React.createElement(View, {
        style: Platform.OS === 'web' ? {
          flex: 2
        } : {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacTextInput, {
        mode: "outlined",
        textAlign: 'left',
        accessibilityLabel: "otherFeesDue",
        nativeID: "otherFeesDue",
        returnKeyType: 'done',
        style: {
          width: layout.mobile ? undefined : 200,
          paddingTop: 10,
          height: 41
        },
        keyboardType: layout.mobile ? "decimal-pad" : "default",
        payment: false,
        onBlur: function () {
          if (parseFloat(_this.replaceDollarSign(_this.getStateValue("otherFeesDue")) || 0) <= 0.01) {
            onChangeFee("0.00", "otherFeesDue");
          } else {
            if (!isNaN(parseFloat(_this.replaceDollarSign(_this.getStateValue("otherFeesDue"))))) {
              onChangeFee(parseFloat(_this.replaceDollarSign(_this.getStateValue("otherFeesDue"))).toFixed(2), "otherFeesDue");
            }
          }
        },
        onFocus: function () {
          if (parseFloat(_this.replaceDollarSign(_this.getStateValue("otherFeesDue")) || 0) <= 0.01) {
            onChangeFee("", "otherFeesDue");
          }
        },
        disabled: parseFloat(_this.replaceDollarSign(_this.getStateValueOriginal("otherFeesDue"))) <= 0,
        name: "otherFeesDue",
        value: "$".concat(_this.replaceDollarSign(_this.getStateValue("otherFeesDue"))),
        onChangeText: function (text) {
          var _a;
          var amount = _this.replaceDollarSign(text);
          if (((_a = amount || "") === null || _a === void 0 ? void 0 : _a.countDecimals()) <= 2) {
            onChangeFee(amount, "otherFeesDue");
          }
        }
      })))), (((_z = _this.state.payment) === null || _z === void 0 ? void 0 : _z.paymentType) == 201298 || ((_0 = _this.state.payment) === null || _0 === void 0 ? void 0 : _0.paymentType) == 201297 || ((_1 = _this.state.payment) === null || _1 === void 0 ? void 0 : _1.paymentType) == 201309) && !((_2 = layout.paymentModel) === null || _2 === void 0 ? void 0 : _2.mustMakeDelinquentPayment) ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          width: "100%",
          paddingHorizontal: 20,
          paddingVertical: 10
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 1
        }
      }, ((_3 = _this.state.payment) === null || _3 === void 0 ? void 0 : _3.paymentType) == 201297 ? /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'principalpaymentamount'
      }, 'Principal Payment Amount') : /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'lblAdditionalPrincipalAmount'
      }, translations.AdditionalPrincipal)), /*#__PURE__*/React.createElement(View, {
        style: Platform.OS === 'web' ? {
          flex: 2
        } : {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacTextInput, {
        mode: "outlined",
        textAlign: 'left',
        returnKeyType: 'done',
        accessibilityLabel: "Additional principal",
        nativeID: "additionalPrincipalAmount",
        style: {
          width: layout.mobile ? undefined : 200,
          paddingTop: 10,
          height: 41
        },
        keyboardType: layout.mobile ? "decimal-pad" : "default",
        payment: false,
        onBlur: function () {
          var _a, _b, _c;
          if (parseFloat(_this.replaceDollarSign((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.additionalPrincipalAmount) || 0) <= 0.01) {
            onChange("0.00", "additionalPrincipalAmount");
          } else {
            if (!isNaN(parseFloat(_this.replaceDollarSign((_b = _this.state.payment) === null || _b === void 0 ? void 0 : _b.additionalPrincipalAmount)))) {
              onChange(parseFloat(_this.replaceDollarSign((_c = _this.state.payment) === null || _c === void 0 ? void 0 : _c.additionalPrincipalAmount)).toFixed(2), "additionalPrincipalAmount");
            }
          }
        },
        onFocus: function () {
          var _a;
          if (parseFloat(_this.replaceDollarSign((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.additionalPrincipalAmount) || 0) <= 0.01) {
            onChange("", "additionalPrincipalAmount");
          }
        },
        value: "$".concat((_4 = _this.state.payment) === null || _4 === void 0 ? void 0 : _4.additionalPrincipalAmount),
        onChangeText: function (text) {
          var _a;
          var amount = _this.replaceDollarSign(text);
          if (((_a = amount || "") === null || _a === void 0 ? void 0 : _a.countDecimals()) <= 2) {
            onChange(amount, "additionalPrincipalAmount");
          }
        }
      })))) : (((_5 = _this.state.payment) === null || _5 === void 0 ? void 0 : _5.paymentType) == 201298 || ((_6 = _this.state.payment) === null || _6 === void 0 ? void 0 : _6.paymentType) == 201297 || ((_7 = _this.state.payment) === null || _7 === void 0 ? void 0 : _7.paymentType) == 201309) && (_this.state.deliquentPayment || layout.paymentModel.numberofPendingPayments > 0) && !((_8 = layout.paymentModel) === null || _8 === void 0 ? void 0 : _8.mustMakeDelinquentPayment) ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          paddingLeft: 20,
          paddingRight: 20,
          marginBottom: 20
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: Platform.OS === 'web' ? {
          flex: 2
        } : {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacTextInput, {
        mode: "outlined",
        textAlign: 'left',
        returnKeyType: 'done',
        accessibilityLabel: "Additional principal",
        nativeID: "additionalPrincipalAmount",
        style: {
          width: layout.mobile ? undefined : 200,
          height: 41
        },
        keyboardType: layout.mobile ? "decimal-pad" : "default",
        payment: false,
        onBlur: function () {
          var _a, _b, _c;
          if (parseFloat(_this.replaceDollarSign((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.additionalPrincipalAmount) || 0) <= 0.01) {
            onChange("0.00", "additionalPrincipalAmount");
          } else {
            if (!isNaN(parseFloat(_this.replaceDollarSign((_b = _this.state.payment) === null || _b === void 0 ? void 0 : _b.additionalPrincipalAmount)))) {
              onChange(parseFloat(_this.replaceDollarSign((_c = _this.state.payment) === null || _c === void 0 ? void 0 : _c.additionalPrincipalAmount)).toFixed(2), "additionalPrincipalAmount");
            }
          }
        },
        onFocus: function () {
          var _a;
          if (parseFloat(_this.replaceDollarSign((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.additionalPrincipalAmount) || 0) <= 0.01) {
            onChange("", "additionalPrincipalAmount");
          }
        },
        value: "$".concat((_9 = _this.state.payment) === null || _9 === void 0 ? void 0 : _9.additionalPrincipalAmount),
        onChangeText: function (text) {
          var _a;
          var amount = _this.replaceDollarSign(text);
          if (((_a = amount || "") === null || _a === void 0 ? void 0 : _a.countDecimals()) <= 2) {
            onChange(amount, "additionalPrincipalAmount");
          }
        }
      })))) : null, ((_10 = layout.currentLoan) === null || _10 === void 0 ? void 0 : _10.escrowFlag) && (((_11 = _this.state.payment) === null || _11 === void 0 ? void 0 : _11.paymentType) == 201298 || ((_12 = _this.state.payment) === null || _12 === void 0 ? void 0 : _12.paymentType) == 201299 || ((_13 = _this.state.payment) === null || _13 === void 0 ? void 0 : _13.paymentType) == 201311) && /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          width: "100%",
          paddingHorizontal: 20,
          paddingVertical: 10
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 1
        }
      }, !layout.mobile ? /*#__PURE__*/React.createElement("label", {
        for: "additionalEscrowAmount"
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'additionalEscrowAmount'
      }, translations.AdditionalPrincipal)) : /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'additionalEscrowAmount'
      }, translations.AdditionalEscrow)), /*#__PURE__*/React.createElement(View, {
        style: Platform.OS === 'web' ? {
          flex: 2
        } : {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacTextInput, {
        mode: "outlined",
        textAlign: 'left',
        returnKeyType: 'done',
        accessibilityLabel: "Additional escrow",
        nativeID: "additionalEscrowAmount",
        style: {
          width: layout.mobile ? undefined : 200,
          paddingTop: 10,
          height: 41
        },
        keyboardType: layout.mobile ? "decimal-pad" : "default",
        payment: false,
        onBlur: function () {
          var _a, _b, _c;
          if (parseFloat(_this.replaceDollarSign((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.additionalEscrowAmount) || 0) <= 0) {
            onChange("0.00", "additionalEscrowAmount");
          } else {
            if (!isNaN(parseFloat(_this.replaceDollarSign((_b = _this.state.payment) === null || _b === void 0 ? void 0 : _b.additionalEscrowAmount)))) {
              onChange(parseFloat(_this.replaceDollarSign((_c = _this.state.payment) === null || _c === void 0 ? void 0 : _c.additionalEscrowAmount)).toFixed(2), "additionalEscrowAmount");
            }
          }
        },
        onFocus: function () {
          var _a;
          if (parseFloat(_this.replaceDollarSign((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.additionalEscrowAmount) || 0) <= 0) {
            onChange("", "additionalEscrowAmount");
          }
        },
        value: "$".concat((_14 = _this.state.payment) === null || _14 === void 0 ? void 0 : _14.additionalEscrowAmount),
        onChangeText: function (text) {
          var _a;
          var amount = _this.replaceDollarSign(text);
          if (((_a = amount || "") === null || _a === void 0 ? void 0 : _a.countDecimals()) <= 2) {
            if (parseFloat(amount) <= 0.02) {
              onChange('0.00', "additionalEscrowAmount");
            } else {
              onChange(amount, "additionalEscrowAmount");
            }
          }
        }
      })))), (_this.state.payment.paymentType == 1000145 || ((_15 = _this.state.payment) === null || _15 === void 0 ? void 0 : _15.paymentType) == 1000146) && (/*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "column",
          paddingLeft: 20,
          marginBottom: 10,
          marginTop: 10,
          paddingRight: 20
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          backgroundColor: '#FFFBE6',
          borderWidth: 2,
          borderStyle: 'solid',
          borderColor: '#F9EB9C',
          padding: 10,
          marginVertical: 10,
          color: '#5C5C5C',
          borderRadius: 5
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          color: '#5C5C5C',
          fontFamily: "Halenoir Compact Medium",
          fontSize: 12
        }
      }, "You are on a Forbearance Plan, which temporarily allows you to stop making regular monthly payments for an agreed period of time. You may choose to pay any amount during this period. ")), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, null, !layout.mobile ? /*#__PURE__*/React.createElement("label", {
        for: "paymentAmount"
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'paymentAmount'
      }, translations.AdditionalPrincipal)) : /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription,
        idTag1: 'paymentAmount'
      }, translations.PaymentAmount)), /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "row",
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: Platform.OS === 'web' ? {
          flex: 2
        } : {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacTextInput, {
        mode: "outlined",
        returnKeyType: 'done',
        textAlign: 'left',
        nativeID: "paymentAmount",
        style: {
          width: '100%',
          paddingTop: 10,
          height: 41
        },
        keyboardType: layout.mobile ? "decimal-pad" : "default",
        payment: false,
        onBlur: function () {
          var _a;
          if (parseFloat(_this.replaceDollarSign((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.forbearanceAmount) || 0) <= 0) {
            onChange("0.00", "forbearanceAmount");
          }
        },
        onFocus: function () {
          var _a;
          if (parseFloat(_this.replaceDollarSign((_a = _this.state.payment) === null || _a === void 0 ? void 0 : _a.forbearanceAmount) || 0) <= 0) {
            onChange("", "forbearanceAmount");
          }
        },
        value: "$".concat((_16 = _this.state.payment) === null || _16 === void 0 ? void 0 : _16.forbearanceAmount),
        onChangeText: function (text) {
          var _a;
          var amount = _this.replaceDollarSign(text);
          if (((_a = amount || "") === null || _a === void 0 ? void 0 : _a.countDecimals()) <= 2) {
            if (parseFloat(amount) <= 0.02) {
              onChange('0.00', "forbearanceAmount");
            } else {
              onChange(amount, "forbearanceAmount");
            }
          }
        }
      })))), /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          paddingLeft: 20,
          marginBottom: 20,
          marginTop: 20,
          paddingRight: 20,
          backgroundColor: '#F7F7F7',
          borderColor: '#CBEAF5',
          borderRadius: 5,
          height: 49
        }
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('TotalPaymentAmount'), {
        style: stylesPaymentMethod.totalPaymentAmountTitle
      }), translations.TotalPaymentAmount), /*#__PURE__*/React.createElement(View, {
        style: stylesModal.rightContent
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('TotalPaymentAmountValue'), {
        style: stylesPaymentMethod.totalPaymentAmountValue
      }), currencyFormatter('en-US', 'currency', 'USD', _this.totalDraftAmountFun())))), /*#__PURE__*/React.createElement(View, {
        style: {
          backgroundColor: '#F0F9FC',
          borderWidth: 2,
          borderColor: '#CBEAF5',
          padding: 10,
          color: '#5C5C5C',
          borderRadius: 5
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          color: '#5C5C5C',
          fontFamily: "Halenoir Compact Medium",
          fontSize: 12
        }
      }, "Any amount that is received less than a full payment will be an applied to a suspense account for your mortgage. When enough is received to equal a full payment, a full payment will be applied to your mortgage. ")))), _this.state.payment.paymentType != 1000145 && ((_17 = _this.state.payment) === null || _17 === void 0 ? void 0 : _17.paymentType) != 1000146 && /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          paddingLeft: 20,
          marginBottom: 20,
          paddingRight: 20,
          marginHorizontal: 15,
          backgroundColor: '#F7F7F7',
          borderColor: '#CBEAF5',
          border: '2',
          borderRadius: 5,
          height: 50
        }
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('TotalPaymentAmount'), {
        style: stylesPaymentMethod.totalPaymentAmountTitle
      }), translations.TotalPaymentAmount), /*#__PURE__*/React.createElement(View, {
        style: stylesModal.rightContent
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('TotalPaymentAmountValue'), {
        style: stylesPaymentMethod.totalPaymentAmountValue
      }), currencyFormatter('en-US', 'currency', 'USD', _this.totalDraftAmountFun())))));
    };
    var getPaymentModel = function () {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
      return /*#__PURE__*/React.createElement(View, {
        className: "row"
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          margin: 5
        }
      }, /*#__PURE__*/React.createElement(PnmacPaper, {
        disabled: true,
        style: stylesPaymentMethod.container
      }, /*#__PURE__*/React.createElement(TouchableOpacity, {
        style: __assign(__assign({}, stylesPaymentMethod.paymentMethodRow), {
          marginRight: 5
        }),
        onPress: function () {
          var _a, _b;
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/Make payment-Payment Method|Mobile', -1, '', false);
          if (((_b = (_a = _this.props.layout.paymentModel) === null || _a === void 0 ? void 0 : _a.bankAccounts) === null || _b === void 0 ? void 0 : _b.length) == 0) {
            _this.props.dispatch({
              type: NACHA_BANKACCOUNT,
              paymentModel: __assign(__assign({}, _this.props.layout.paymentModel), {
                selectedView: 'PaymentMethodAddBankAccount'
              })
            });
          } else {
            _this.props.dispatch({
              type: NACHA_BANKACCOUNT,
              paymentModel: __assign(__assign({}, _this.props.layout.paymentModel), {
                selectedView: 'PaymentMethodSelectBankAccount'
              })
            });
          }
        }
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('PaymentMethod'), {
        style: __assign(__assign({}, stylesPaymentMethod.paymentMethodTitle), {
          fontColor: '#1B1B1B !important'
        })
      }), translations.PaymentMethod), /*#__PURE__*/React.createElement(View, {
        style: {
          flexDirection: "row",
          alignItems: "center",
          justifyContent: 'flex-end'
          // flex: 0.84
        }
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('PaymentMethodValue'), {
        style: {
          fontFamily: 'HalenoirCompactText-Medium',
          color: '#1B1B1B',
          marginRight: 5,
          maxWidth: width * 0.43
        }
      }), "".concat(((_a = getSelectBankAccount()) === null || _a === void 0 ? void 0 : _a.bankAccountType) === 201286 ? translations.CheckingAccount + ' **' : ((_b = getSelectBankAccount()) === null || _b === void 0 ? void 0 : _b.bankAccountType) === 201287 ? translations.SavingsAccount + ' **' : ((_c = getSelectBankAccount()) === null || _c === void 0 ? void 0 : _c.bankAccountType) === 201288 ? "Debit Card" : "Add Account"), (_e = (_d = getSelectBankAccount()) === null || _d === void 0 ? void 0 : _d.accountNumber) === null || _e === void 0 ? void 0 : _e.slice(-4)), /*#__PURE__*/React.createElement(View, {
        style: {
          marginLeft: 'auto'
        }
      }, /*#__PURE__*/React.createElement(Image, {
        alt: "View details",
        source: require("./../../../assets/cheveron-black-right.jpg")
      })))), /*#__PURE__*/React.createElement(View, {
        style: stylesPaymentMethod.divider
      }), edit && /*#__PURE__*/React.createElement(View, {
        style: {
          paddingTop: 10,
          paddingBottom: 0,
          paddingLeft: 15,
          paddingRight: 15,
          backgroundColor: "#fff"
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          backgroundColor: "#1279A5",
          padding: 10,
          width: "100%",
          borderRadius: 10,
          alignSelf: "center"
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        idTag1: 'lblOtpEditingPendingPayment',
        style: __assign(__assign({}, textStyle.defaultTextDescription), {
          color: "#FFF"
        })
      }, "".concat(translations.OtpEditingPendingPayment, " ").concat(moment((_k = _this.props.layout.mobile ? (_g = (_f = _this.props.route) === null || _f === void 0 ? void 0 : _f.params) === null || _g === void 0 ? void 0 : _g.payment : (_j = (_h = _this.props.location) === null || _h === void 0 ? void 0 : _h.state) === null || _j === void 0 ? void 0 : _j.payment) === null || _k === void 0 ? void 0 : _k.effectiveDate).format("MM/DD/YYYY"))))), _this.state.payment.paymentType != 1000145 && ((_l = _this.state.payment) === null || _l === void 0 ? void 0 : _l.paymentType) != 1000146 && (_this.state.payment.paymentType == 201296 ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
        style: stylesPaymentMethod.paymentMethodRow
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('PaymentType'), {
        style: stylesPaymentMethod.paymentMethodTitle
      }), translations === null || translations === void 0 ? void 0 : translations.PaymentType), /*#__PURE__*/React.createElement(View, {
        style: {
          flexDirection: "row",
          alignItems: "center",
          justifyContent: 'flex-end'
        }
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('bankacctype'), {
        style: {
          fontSize: 14,
          fontFamily: 'HalenoirCompactText-Medium',
          color: '#1B1B1B',
          padding: 5
        }
      }), getSelectedPaymentType()))), /*#__PURE__*/React.createElement(View, {
        style: stylesPaymentMethod.divider
      })) : /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(TouchableOpacity, {
        style: __assign(__assign({}, stylesPaymentMethod.paymentMethodRow), {
          marginRight: 5
        }),
        onPress: function () {
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "OTP/Make payment-Payment Type |Mobile", -1, '', false);
          _this.props.dispatch({
            type: NACHA_BANKACCOUNT,
            paymentModel: __assign(__assign({}, _this.props.layout.paymentModel), {
              selectedView: 'PaymentMethodType'
            })
          });
        }
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('PaymentType'), {
        style: stylesPaymentMethod.paymentMethodTitle
      }), translations === null || translations === void 0 ? void 0 : translations.PaymentType), /*#__PURE__*/React.createElement(View, {
        style: {
          flexDirection: "row",
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('bankacctype'), {
        style: {
          fontSize: 14,
          fontFamily: 'HalenoirCompactText-Medium',
          color: '#1B1B1B',
          padding: 5,
          flexDirection: "row",
          maxWidth: width * 0.4
        }
      }), getSelectedPaymentType()), /*#__PURE__*/React.createElement(View, {
        style: {
          marginLeft: 'auto'
          // marginRight: 15
        }
      }, /*#__PURE__*/React.createElement(Image, {
        alt: "View details",
        source: require("./../../../assets/cheveron-black-right.jpg")
      })))), /*#__PURE__*/React.createElement(View, {
        style: __assign(__assign({}, stylesPaymentMethod.divider), {
          marginBottom: 15
        })
      }))), isDeliquentPayment() ? getDeliquentPayment() : getNonDeliquentPaymentComponent(), /*#__PURE__*/React.createElement(View, {
        style: stylesPaymentMethod.divider
      }), /*#__PURE__*/React.createElement(TouchableOpacity, {
        style: stylesPaymentMethod.paymentMethodRow,
        onPress: function () {
          _this.setState({
            currentSelectedDate: moment(_this.state.payment.effectiveDate).format('YYYY-MM-DD')
          }, function () {
            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/Make payment-Payment Date |Mobile', -1, '', false);
            _this.props.dispatch({
              type: NACHA_BANKACCOUNT,
              paymentModel: __assign(__assign({}, _this.props.layout.paymentModel), {
                selectedView: 'PaymentMethodSelectDate'
              })
            });
          });
        }
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('TotalPaymentAmount'), {
        style: stylesPaymentMethod.totalPaymentAmountTitle
      }), isOtp ? layout.mobile ? /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription
      }, translations.EffectiveDate) : /*#__PURE__*/React.createElement("label", {
        for: "EffectiveDateInput"
      }, /*#__PURE__*/React.createElement(PnmacToolTip, {
        style: textStyle.defaultTextDescription,
        text: translations.EffectiveDate,
        title: translations.EffectiveDateMessage
      })) : layout.mobile ? /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription
      }, translations.DraftDate) : /*#__PURE__*/React.createElement("label", {
        for: "EffectiveDateInput"
      }, /*#__PURE__*/React.createElement(PnmacToolTip, {
        style: textStyle.defaultTextDescription,
        text: translations.DraftDate,
        title: translations.EffectiveDateMessage
      }))), /*#__PURE__*/React.createElement(View, {
        style: {
          flexDirection: "row",
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('effectivedate'), {
        style: {
          fontSize: 14,
          fontFamily: 'HalenoirCompactText-Medium',
          color: '#1B1B1B',
          padding: 5
        }
      }), moment(_this.state.payment.effectiveDate).format("MMMM DD,YYYY")), /*#__PURE__*/React.createElement(View, {
        style: {
          marginLeft: 'auto',
          marginRight: 10
        }
      }, /*#__PURE__*/React.createElement(Image, {
        alt: "View details",
        source: require("./../../../assets/cheveron-black-right.jpg")
      })))), !isDeliquentPayment() && (_this.state.payment.paymentType == 201298 || _this.state.payment.paymentType == 201311) && moment(_this.state.payment.effectiveDate).isSameOrAfter(moment((_m = layout.currentLoan) === null || _m === void 0 ? void 0 : _m.lateChargeGraceEndDate).add('days', 1).set("month", moment(nextPaymentDueDate).month())) && isOtp && moment(layout.localTime).month() >= moment(originalNextPaymentDueDate).month() ? /*#__PURE__*/React.createElement(BannerView, {
        style: {
          margin: 15
        },
        type: 'warning'
      }, /*#__PURE__*/React.createElement(BannerView.Text, null, translations === null || translations === void 0 ? void 0 : translations.PaymentPastGracePeriod, " ", moment((_o = layout.currentLoan) === null || _o === void 0 ? void 0 : _o.lateChargeGraceEndDate).set("month", moment(nextPaymentDueDate).month()).format("MM/DD/YYYY"), " ", translations === null || translations === void 0 ? void 0 : translations.AdditionalLateFee, " ", currencyFormatter('en-US', 'currency', 'USD', (_p = layout.currentLoan) === null || _p === void 0 ? void 0 : _p.quotedLateChargeFeeAmount))) : null, !isDeliquentPayment() && (_this.state.payment.paymentType == 201298 || _this.state.payment.paymentType == 201311) && moment((_q = _this.state.payment) === null || _q === void 0 ? void 0 : _q.effectiveDate).isSameOrAfter(aheadOneMonth) && isOtp && moment(layout.localTime).month() >= moment(originalNextPaymentDueDate).month() ? /*#__PURE__*/React.createElement(BannerView, {
        style: {
          margin: 15
        }
      }, /*#__PURE__*/React.createElement(BannerView.Text, null, translations.AdverseCredit)) : null, isDeliquentPayment() && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
        style: {
          backgroundColor: '#FFFBE6',
          borderWidth: 2,
          borderStyle: 'solid',
          borderColor: '#F9EB9C',
          padding: 10,
          marginHorizontal: 15,
          marginVertical: 10,
          color: '#5C5C5C',
          borderRadius: 5
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          color: '#5C5C5C',
          fontFamily: "Halenoir Compact Medium",
          fontSize: 12
        }
      }, translations === null || translations === void 0 ? void 0 : translations.PaymentPastGracePeriod, " ", moment((_r = layout.currentLoan) === null || _r === void 0 ? void 0 : _r.lateChargeGraceEndDate).set("month", moment(nextPaymentDueDate).month()).format("MM/DD/YYYY"), " ", translations === null || translations === void 0 ? void 0 : translations.AdditionalLateFee, " ", currencyFormatter('en-US', 'currency', 'USD', (_s = layout.currentLoan) === null || _s === void 0 ? void 0 : _s.quotedLateChargeFeeAmount))), /*#__PURE__*/React.createElement(View, {
        style: {
          backgroundColor: '#F0F9FC',
          borderWidth: 2,
          borderColor: '#CBEAF5',
          padding: 10,
          marginHorizontal: 15,
          color: '#5C5C5C',
          borderRadius: 5,
          marginBottom: 15
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          color: '#5C5C5C',
          fontFamily: "Halenoir Compact Medium",
          fontSize: 12
        }
      }, translations.MonthlyPayments30DaysPastDueDate))), /*#__PURE__*/React.createElement(View, {
        style: stylesPaymentMethod.divider
      }))), _this.checkPaymentOver() ? /*#__PURE__*/React.createElement(BannerView, {
        type: 'error',
        style: {
          marginTop: 10,
          marginHorizontal: 15
        }
      }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, _this.props, {
        layout: _this.props.layout,
        value: translations === null || translations === void 0 ? void 0 : translations.DefaultPaymentsPayoffMessage
      }))) : null, /*#__PURE__*/React.createElement(View, {
        style: __assign(__assign({}, stylesPaymentMethod.bottomContent), {
          paddingBottom: 15
        })
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        nativeID: "btnContinueButton",
        style: {
          margingTop: 5,
          height: 47.4,
          justifyContent: 'center',
          textAlign: 'center'
        },
        loading: _this.state.paymentSubmitted,
        disabled: monthlyPaymentdisabled && principalReductionedisabled && additionalAmountDisabled || _this.state.isNachaOpen || _this.checkPaymentOver() ||
        // (this.state.payment?.bankAccount == null || !this.state.payment?.bankAccount?.accountNumber)
        getSelectBankAccount() == undefined || ((_t = getSelectBankAccount()) === null || _t === void 0 ? void 0 : _t.unmaskedAccountNumber) == undefined || !edit && ((_v = (_u = _this.props.layout.paymentModel) === null || _u === void 0 ? void 0 : _u.bankAccounts) === null || _v === void 0 ? void 0 : _v.length) == 0 && isOtp && parseInt(bankAccountType) != 201288 || paymentWindow && isTrialPaymentVisible || _this.totalDraftAmountFun() <= (bankAccountType == 201288 ? 6.75 : 0) || disableDate(moment((_x = (_w = _this.state) === null || _w === void 0 ? void 0 : _w.payment) === null || _x === void 0 ? void 0 : _x.effectiveDate)) || !((_z = (_y = _this.state) === null || _y === void 0 ? void 0 : _y.payment) === null || _z === void 0 ? void 0 : _z.effectiveDate),
        mode: "contained",
        testID: "ContinueButtonText",
        onPress: function () {
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/Make payment-Pay now |Mobile', -1, bankAccountType, false);
          if (parseInt(bankAccountType) == 201288) {
            _this.setState({
              openDebit: true
            });
          } else if (isOtp) {
            _this.setState({
              modalType: "effectiveDateConfirmation",
              open: true,
              tabProgression: __spreadArray(__spreadArray([], tabProgression, true), ["bank"], false)
            });
            if (isDeliquentPayment) {
              paymentCallBack(true);
            } else {
              paymentCallBack();
            }
          } else {
            _this.setState({
              page: "bank",
              tabProgression: __spreadArray(__spreadArray([], tabProgression, true), ["bank"], false)
            });
          }
        }
      }, 'Pay Now')));
    };
    var getSelectedView = function () {
      switch (_this.props.layout.paymentModel.selectedView) {
        case 'PaymentMethodOneTimePayment':
          return getPaymentModel();
        case 'PaymentMethodAddBankAccount':
        case 'PaymentMethodSelectBankAccount':
        case 'PaymentMethodDeleteBankAccount':
          return getBankAccountTypeSelectionOptions();
        case 'PaymentMethodSelectDate':
          return getCalendar();
        case 'PaymentMethodType':
          return getPaymentType();
        default:
          return getPaymentModel();
      }
    };
    var otpDescriptionContent = [{
      title: 'Payment Type',
      value: paymentTypes[this.state.payment.paymentType]
    }, {
      title: 'Bank Routing and Transit',
      value: (_w = getSelectBankAccount()) === null || _w === void 0 ? void 0 : _w.routingTransitNumber
    }, {
      title: 'Bank Account ',
      value: maskBankInfo((_x = getSelectBankAccount()) === null || _x === void 0 ? void 0 : _x.unmaskedAccountNumber)
    }, {
      title: 'Name on Account',
      value: (_y = getSelectBankAccount()) === null || _y === void 0 ? void 0 : _y.accountName
    }];
    var getPaymentConfirmationRenderModel = function () {
      var _a;
      return /*#__PURE__*/React.createElement(View, {
        style: {
          borderRadius: 8,
          backgroundColor: '#ffffff',
          marginVertical: 30
        }
      }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          flexDirection: 'coloumn',
          alignItems: 'center',
          justifyContent: 'space-around',
          paddingHorizontal: 32,
          borderBottomColor: '#1B1B1B',
          borderBottomWidth: 0.5,
          paddingVertical: 15,
          paddingBottom: 20,
          marginLeft: 10,
          marginRight: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('AutoPayDetails'), {
        style: __assign(__assign({}, theme.textStyle.modalTitle), {
          fontFamily: "Montserrat",
          fontWeight: "bold",
          textAlign: 'center',
          fontSize: 22,
          color: "#333333",
          marginBottom: 10
        })
      }), "Confirm Payment"), /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('TotalDraftAmount'), {
        style: stylesModal.paymentValue
      }), currencyFormatter('en-US', 'currency', 'USD', _this.totalDraftAmountFun())), /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('DraftDate'), {
        style: {
          fontFamily: "HalenoirCompactText-Medium",
          fontSize: 13,
          color: "#5C5C5C"
        }
      }), "Effective Date: ".concat(moment(_this.state.payment.effectiveDate, "MM/DD/YYYY").isValid() ? moment(_this.state.payment.effectiveDate, "MM/DD/YYYY").format("MMMM DD, YYYY") : moment(_this.state.payment.effectiveDate).format("MMMM DD, YYYY")))), /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          borderBottomColor: '#1B1B1B',
          borderBottomWidth: 0.5,
          paddingBottom: 15,
          paddingTop: 15,
          marginLeft: 10,
          marginRight: 10
        }
      }, otpDescriptionContent.map(function (item, index) {
        return /*#__PURE__*/React.createElement(View, {
          key: index,
          style: stylesModal.autoPayDetailsRow
        }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID(item.title.replace(/ /g, "")), {
          style: stylesModal.autoPayDetailsDescriptionTitle
        }), item.title), /*#__PURE__*/React.createElement(View, {
          style: styles.rightContent
        }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID(item.title.replace(/ /g, "") + 'value'), {
          style: stylesModal.autoPayDetailsDescriptionTitle
        }), item.value)));
      })), /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-around',
          paddingVertical: 15,
          paddingHorizontal: 8,
          marginLeft: 10,
          marginRight: 10
        }
      }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(HtmlToNativeNative, {
        value: translations.PaymentTermsDescription
      }))), getSelectBankAccount() && /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-around',
          paddingHorizontal: 8,
          marginLeft: 10,
          marginRight: 10
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('BankInfoWarningMessage'), {
        ellipsizeMode: "tail",
        style: __assign(__assign({}, stylesModal.autoPayDetailsDescriptionTitle), {
          textAlign: 'center'
        })
      }), translations.BankInfoWarningLine1, " ", currencyFormatter('en-US', 'currency', 'USD', _this.totalDraftAmountFun()), " ", translations.BankInfoWarningLine2, " ", (_a = getSelectBankAccount()) === null || _a === void 0 ? void 0 : _a.accountNumber))), /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-around',
          paddingHorizontal: 8,
          paddingVertical: 15
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        nativeID: "btnSubmitButtonPnmacText",
        name: "SubmitButtonPnmacText",
        testId: "SubmitButtonPnmacText",
        style: {
          width: '80%',
          height: 47,
          justifyContent: "center"
        },
        loading: _this.state.paymentSubmitted,
        disabled: layout.pennyWise,
        mode: "contained",
        testID: "SubmitButtonPnmacText",
        onPress: function () {
          _this.submitPayment(getSelectBankAccount());
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/Confirm Modal -Submit|Mobile', -1, '', false);
        }
      }, translations.SubmitButtonPnmacText), /*#__PURE__*/React.createElement(PnmacUIButton, {
        marginTop: 15,
        marginBottom: 10,
        style: {
          width: '80%',
          height: 47,
          justifyContent: "center",
          marginBottom: 10
        },
        nativeID: "btnCancelButtonPnmacText",
        disabled: _this.state.paymentSubmitted,
        testId: "CancelButtonPnmacText",
        mode: "outlined",
        testID: "CancelButtonPnmacText",
        onPress: function () {
          _this.setState({
            open: false
          });
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/Confirm Modal -Previous|Mobile', -1, '', false);
        }
      }, 'Previous'))));
    };
    var paymentCallBack = function (go) {
      var _a, _b, _c, _d, _e, _f;
      if (go || layout.paymentModel.pendingPayments.filter(function (w) {
        return w.paymentType == 201298 || w.paymentType == 201311;
      }).length == 0 && !edit) {
        if (!_this.state.deliquentPayment && ((_a = layout.paymentModel) === null || _a === void 0 ? void 0 : _a.mustMakeDelinquentPayment) && !go && !((modifications === null || modifications === void 0 ? void 0 : modifications.statusTypeId) > 0 && (modifications === null || modifications === void 0 ? void 0 : modifications.isForebearanceOTPVisible)) && !((_b = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _b === void 0 ? void 0 : _b.isLoanInForbearance) && _this.isLoanInForbearance() == false) {
          /// this one can be removed with legacy delinquent payments
          _this.setState({
            modalType: "oneDelinquentPayment"
          });
        } else {
          if (_this.state.payment.delinquentPayments.filter(function (s) {
            return s.paid == false && s.mandatory == false;
          }).length != _this.state.payment.delinquentPayments.filter(function (s) {
            return s.paid == false && s.mandatory == false && s.selected == true;
          }).length && _this.state.modalType != "oneDelinquentPayment" && !((_c = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _c === void 0 ? void 0 : _c.isLoanInForbearance) && _this.isLoanInForbearance() == false) {
            _this.setState({
              modalType: "oneDelinquentPayment"
            });
          } else {
            _this.setState({
              modalType: "paymentConfirmation",
              open: true
            });
          }
        }
      } else {
        if (edit) {
          _this.setState({
            modalType: "paymentConfirmation",
            confirmation: true,
            open: true
          });
        } else {
          if (((_f = (_e = (_d = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _d === void 0 ? void 0 : _d.pendingPayments) === null || _e === void 0 ? void 0 : _e.filter(function (w) {
            return ((w === null || w === void 0 ? void 0 : w.paymentType) == 201298 || (w === null || w === void 0 ? void 0 : w.paymentType) == 201311) && (w === null || w === void 0 ? void 0 : w.status) != 201295;
          })) === null || _f === void 0 ? void 0 : _f.length) > 0) {
            _this.setState({
              modalType: "pendingOneTimePayment"
            });
          } else {
            _this.setState({
              page: "confirm",
              confirmation: true,
              open: false
            });
          }
        }
      }
    };
    return /*#__PURE__*/React.createElement(View, {
      style: {
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10,
        overflow: 'hidden'
      }
    }, ((_z = Object.keys(errors)) === null || _z === void 0 ? void 0 : _z.length) > 0 ? /*#__PURE__*/React.createElement(PnmacCard, {
      style: {
        padding: 15,
        backgroundColor: "pink"
      }
    }, Object.keys(errors).map(function (s) {
      return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription
      }, errors[s]));
    })) : null, /*#__PURE__*/React.createElement(React.Fragment, null, getSelectedView()), /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
      }
    }, /*#__PURE__*/React.createElement(TransitionsModal, __assign({
      firstMonthlyPaymentDate: pendingPaymentDate === null || pendingPaymentDate === void 0 ? void 0 : pendingPaymentDate.effectiveDate,
      nextPaymentDueDate: nextPaymentDueDate,
      displayedConfirmationId: displayedConfirmationId,
      matches: matches,
      getPaymentConfirmationRenderModel: getPaymentConfirmationRenderModel,
      location: this.props.location,
      paymentCallback: function (go) {
        paymentCallBack(go);
      },
      showPaymentModel: function () {
        _this.setState({
          open: false
        }, function () {
          return _this.props.dispatch({
            type: NACHA_BANKACCOUNT,
            paymentModel: __assign(__assign({}, _this.props.layout.paymentModel), {
              selectedView: 'PaymentMethodOneTimePayment'
            })
          });
        });
      },
      history: this.props.history,
      modalType: this.state.modalType,
      layout: layout,
      translations: translations,
      open: this.state.open && this.state.page != 'confirm' && this.state.modalType != 'pendingPayments'
    }, this.props, {
      closeModal: function () {
        return _this.setState({
          open: false
        });
      }
    }))));
  };
  return OneTimePaymentNative;
}(React.Component);
export default OneTimePaymentNative;
var stylesModal = StyleSheet.create({
  container: {
    padding: 0,
    backgroundColor: "white",
    borderRadius: 7,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginHorizontal: 15,
    marginTop: 30
  },
  editContainer: {
    padding: 0,
    backgroundColor: "white",
    borderRadius: 7,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginHorizontal: 15,
    marginTop: 30
  },
  paymentMethodRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    height: 62.8,
    alignItems: "center",
    paddingLeft: 17.5,
    paddingRight: 14.5
  },
  paymentMethodTitle: {
    fontFamily: "HalenoirCompactText-Medium",
    fontSize: 14,
    color: "#5C5C5C"
  },
  divider: {
    height: 1,
    width: "100%",
    backgroundColor: "#CCCCCC"
  },
  innerDivider: {
    height: 1,
    width: "90%",
    backgroundColor: "#CCCCCC",
    alignSelf: "center",
    marginBottom: 20
  },
  rightContent: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: 'flex-end',
    flex: 0.8
  },
  chevronRight: {
    marginLeft: 7.9,
    width: 10,
    height: 10,
    transform: [{
      rotate: '180deg'
    }]
  },
  inputContainer: {
    marginHorizontal: 19
  },
  input: {
    height: 41,
    marginTop: 9.9
  },
  totalPaymentAmountContainer: {
    backgroundColor: "#F7F7F7",
    borderRadius: 5,
    minHeight: 43,
    marginHorizontal: 18,
    marginTop: 19.1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: 13.5,
    paddingRight: 14,
    marginBottom: 17.9
  },
  totalPaymentAmountTitle: {
    color: "#1B1B1B",
    fontFamily: "HalenoirCompactText-Medium",
    fontSize: 14
  },
  totalPaymentAmountValue: {
    color: "#117AAA",
    fontFamily: "HalenoirCompactText-Bold",
    fontWeight: "bold",
    fontSize: 14
  },
  paymentDateRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    height: 62.8,
    alignItems: "center",
    paddingLeft: 17.5,
    paddingRight: 14.5
  },
  paymentDateTitle: {
    fontFamily: "HalenoirCompactText-Medium",
    fontSize: 14,
    color: "#5C5C5C"
  },
  paymentBottomInfo: {
    fontFamily: "HalenoirCompactText-Medium",
    fontSize: 14,
    color: "#5C5C5C"
  },
  bottomInfoContainer: {
    marginTop: 15
  },
  bottomContent: {
    marginHorizontal: 15
  },
  paymentValue: {
    fontFamily: "Montserrat",
    fontWeight: "bold",
    fontSize: 32,
    color: "#117AAA",
    marginTop: 4.4,
    marginBottom: 10
  },
  autoPayDetailsRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: 5,
    paddingRight: 5
  },
  autoPayDetailsDescriptionTitle: {
    fontFamily: "HalenoirCompactText-Medium",
    fontSize: 13,
    color: "#5C5C5C",
    textAlign: 'center'
  },
  autoPayDetailsPaymentsTitle: {
    fontFamily: "HalenoirCompactText-Bold",
    fontSize: 14,
    color: "#117AAA"
  },
  togglecontainer: {
    justifyContent: 'center',
    alignContent: 'center'
  },
  inner: {
    width: 13,
    height: 13,
    backgroundColor: 'white',
    borderRadius: 15
  },
  outer: {
    width: 28,
    height: 18,
    borderRadius: 18,
    alignItems: 'center',
    flexDirection: 'row',
    padding: 3
  }
});